// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T23:00:59.898Z
// Property: Cypress at Lewisville Apartment Homes (ID: 6767906449167598)
// Collections: 27 amenities, 21 floorplans (live), 44 photos, 78 POIs, 4 reviews, 2 virtual tours, 6 office hours, 18 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167598",
  "property_external_id": "1124098",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/cypress-at-lewisville-apartment-homes-lewisville-tx/wchy8rh/",
  "property_google_business_url": "https://www.google.com/maps/place/Cypress+at+Lewisville+Apartment+Homes/@33.0040488,-97.0203629,959m/data=!3m2!1e3!4b1!4m6!3m5!1s0x864c2c3a8aca6267:0xdbaf8b76261fb06f!8m2!3d33.0040488!4d-97.0203629!16s%2Fg%2F1263c51gj?entry=ttu&g_ep=EgoyMDI2MDkxNC4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "1124098 p1099050",
  "property_status": null,
  "property_slug": "cypress-at-lewisville-apartment-homes",
  "property_name": "Cypress at Lewisville Apartment Homes",
  "property_website_url": "https://www.cypressatlewisville.com/",
  "property_domain": "https://www.cypressatlewisville.com/",
  "property_address": "2436 S Valley Pkwy",
  "property_full_address": "2436 S Valley Pkwy, Lewisville, TX 75067",
  "property_address_1": "2436 S Valley Pkwy",
  "property_address_2": null,
  "property_address_city": "Lewisville",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "75067",
  "property_address_country": "US",
  "property_address_county": "Denton County",
  "property_neighborhood_address": "Lewisville/Flower Mound",
  "property_address_latitude": "33.0040259",
  "property_address_longitude": "-97.01944119999999",
  "property_email": "rentcafe.cy@pricekc.com",
  "property_phone": "(972) 752-2236",
  "property_call_tracking_phone": "972-752-2236",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Polished Lewisville living starts here.</strong> Explore one-, two-, and three-bedroom <a href=\"/floor-plans\">floor plans</a> with granite countertops, stainless steel appliances, spacious closets, and access to standout spaces like a resort-style pool, fitness center, and clubhouse lounge—then <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_long_description": "<p><strong>Polished Lewisville living, connected to everything you need.</strong> At Cypress at Lewisville Apartment Homes, you can choose from one-, two-, and three-bedroom <a href=\"/floor-plans\">floor plans</a> designed with upscale everyday details—granite countertops, stainless steel appliances, kitchen islands or breakfast bars, spacious closets, garden tubs, and available attached or breezeway garages.</p><p>Outside your door, the community keeps the pace easy with a gated setting, beautifully landscaped grounds, a resort-style pool with private cabanas, outdoor grilling lounge with fireplaces and TV, bark park, clubhouse coffee lounge, business center, 24-hour fitness center, and complimentary fitness classes. The Lewisville/Flower Mound location puts you near The Market at Valley Parkway for Tom Thumb, The Great Greek, pizza, sushi, and daily errands, with quick access to FM 3040, TX-121, and I-35E. When you want more room to roam, explore <a href=\"/neighborhood\">nearby highlights</a> like Old Town Lewisville, LLELA Nature Preserve, Grapevine Lake, and the DCTA A-train connections across Denton County and Dallas.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01023-9da5-714b-902b-fd21e45322ee.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas.",
    "public_id": "01a01023-9da5-714b-902b-fd21e45322ee",
    "storage_key": "property/6767906449167598/01a01023-9da5-714b-902b-fd21e45322ee.webp",
    "width": 1200,
    "height": 675
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "363",
  "property_year_built": "2012",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.28650137741047",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $175-375",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.",
  "property_pet_policy_description": "The non-refundable fee is $300 for 1 pet, and $500 for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://cypressatlewisville.securecafeapplicant.com/onlineleasing/content3/access/cypress-at-lewisville/floorplans",
  "property_resident_portal_url": "https://cypressatlewisville.securecafe.com/residentservices/cypress-at-lewisville/userlogin.aspx",
  "property_apply_now_url": "https://cypressatlewisville.securecafeapplicant.com/onlineleasing/content3/access/cypress-at-lewisville/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-cfe4-70ed-9bde-25eebf3d6688.webp",
  "property_primary_logo_media": {
    "alt_text": "Cypress at Lewisville logo",
    "public_id": "019fc979-cfe4-70ed-9bde-25eebf3d6688",
    "storage_key": "property/6767906449167598/019fc979-cfe4-70ed-9bde-25eebf3d6688.webp",
    "width": 900,
    "height": 324
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97a-e904-756c-a37c-b27fe82afc7a.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019fc97a-e904-756c-a37c-b27fe82afc7a",
    "storage_key": "property/6767906449167598/019fc97a-e904-756c-a37c-b27fe82afc7a.webp",
    "width": 900,
    "height": 324
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97a-de6a-734f-85fe-ce0ab9eb8aac.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019fc97a-de6a-734f-85fe-ce0ab9eb8aac",
    "storage_key": "property/6767906449167598/019fc97a-de6a-734f-85fe-ce0ab9eb8aac.webp",
    "width": 900,
    "height": 324
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#4F2C1D",
  "property_secondary_color": "#78BE20",
  "property_font_color": null,
  "property_color_4": "#EEE5E9",
  "property_color_3": "#4298B5",
  "property_color_5": "#DE541E",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "673 - 1377",
  "property_sqft_min": "673",
  "property_sqft_max": "1377",
  "property_price_range": "1302 - 7940",
  "property_price_min": "1302",
  "property_price_max": "7940",
  "property_available_units": 27,
  "property_facebook_url": "https://www.facebook.com/CypressAtLewisville/",
  "property_instagram_url": "https://www.instagram.com/cypressatlewisville/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJZ2LKijosTIYRb7AfJnaLr9s",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Cypress at Lewisville Apartment Homes",
  "property_home_romance_title": "Find Your Sanctuary in Our Charming Apartment Community",
  "property_home_amenities_blurb": "<p><strong>From coffee to cabanas, amenities keep the day moving.</strong> Enjoy a clubhouse, 24-hour fitness center, swimming pool with sun shelf, private cabanas, outdoor kitchen, grilling area, fireside lounge, and planned community activities. Inside, granite countertops, ceramic tile backsplashes, stainless steel appliances, garden tubs, spacious closets, and available attached garages add everyday polish to these Lewisville apartments.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with room to choose.</strong> Explore one-, two-, and three-bedroom apartments in Lewisville with open living areas, walk-in closets, washer and dryer connections, and select attached garages. Inside select homes, granite countertops, stainless steel appliances, breakfast bars or islands, garden tubs, built-in bookshelves, and 9-foot or vaulted ceilings add everyday polish.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture the details.</strong> Preview sunlit kitchens with granite counters, stainless steel appliances, and dark cabinetry, then look closer at open living areas with tall ceilings and ceiling fans. The gallery also captures landscaped walkways, a sparkling pool with cabanas and loungers, an outdoor grill lounge with fireplaces and a TV, plus everyday extras like spacious closets, garden tubs, attached garage options, and a bark park.</p>",
  "property_home_neighborhood_blurb": "<p>Cypress at Lewisville sits minutes from TX-121 and I-35E, with DFW Airport a short drive away for work trips and weekend getaways. Visit our neighborhood page to see shopping, dining, and parks nearby.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents have plenty to love at Cypress at Lewisville.</strong> Reviews highlight responsive service, a peaceful setting, clean community spaces, and amenities that stay well cared for. You’ll also see praise for spacious, stylish apartments, smooth maintenance experiences, a fabulous pool, and easy access to Lewisville and Flower Mound shopping and dining. Read the reviews to see why Cypress is so often recommended.</p>",
  "property_neighborhood_blurb": "<p>Cypress at Lewisville Apartment Homes is located at 2436 S. Valley Parkway in Lewisville, TX 75067, minutes from Music City Mall, Vista Ridge Plaza, Walmart, and The Market at Valley Parkway. TX-121 and I-35E are close by, and DFW Airport is a short drive away.</p><p>Looking for a place to eat? Our team recommends Phat Bae and Chante Mexican Grill &amp; Cantina, followed by dessert at Tongue in Cheek Ice Cream. The Human Bean and Bahama Bucks are also nearby for coffee and shaved ice.</p><p>For time outside, residents head to Rockledge Park, the LLELA Nature Preserve, Grapevine Lake, and the Grapevine Golf Course.</p><p>Explore the map below for more destinations near Cypress at Lewisville.</p><p>I wrote the ice cream shop as “Tongue in Cheek Ice Cream.” Confirm the exact spelling of that name and Phat Bae against their Google listings, since AI tools match on exact business names.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that work beautifully from morning to night.</strong> Start your day with coffee in the clubhouse, fit in a workout on your schedule at the 24-hour fitness center, then unwind by the swimming pool with a sun shelf and private cabanas. When you feel like staying social, the outdoor kitchen, grilling area, fireside lounge, and planned community activities give you more ways to enjoy home.</p><p>Inside these Lewisville apartments, everyday details feel elevated: granite countertops, ceramic tile backsplashes, stainless steel appliances, side-by-side refrigerators, garden tubs, spacious closets, and available 9-foot ceilings or attached garages. Gated access, valet trash service, on-call maintenance, a bark park, and online services add practical ease. Browse the <a href=\"/gallery\">photo gallery</a>, review layouts on the <a href=\"/floor-plans\">floor plans page</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the amenities in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Cypress at Lewisville home?</strong> Choose your one-, two-, or three-bedroom <a href=\"/floor-plans\">floor plan</a>, enjoy polished finishes like granite countertops and stainless steel appliances, and start your application online today for connected Lewisville living with everyday comfort built in.</p>",
  "property_contactus_blurb": "<p><strong>Have questions? We’re here to help.</strong> Contact the Cypress at Lewisville leasing team for details on our one-, two-, and three-bedroom apartment homes, upscale finishes, available garages, or directions to our connected Lewisville/Flower Mound location near FM 3040, TX-121, and I-35E.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Cypress at Lewisville?</strong> Start here for quick answers about the community, leasing, <a href=\"/floor-plans\">floor plans</a>, amenities, and everyday living. If you don’t see what you need, the <a href=\"/contact-us\">leasing team</a> is happy to help.</p>",
  "property_floorplans_blurb": "<p>Cypress at Lewisville Apartment Homes offers 21 floor plans, including one-, two-, and three-bedroom apartments up to 1,394 square feet. Choose an efficient one-bedroom, or a two- or three-bedroom with room for a home office, guests, or roommates.</p><p><br></p><p>Every floor plan includes stainless steel appliances, granite countertops, and a kitchen island with a smooth-top range. Select floor plans add 9-foot ceilings and an attached garage.</p><p><br></p><p>Preview the A3 one-bedroom and B2 two-bedroom with a 360 virtual tour, or schedule a tour to see a floor plan in person.</p>",
  "property_gallery_blurb": "<p>Browse photos of Cypress at Lewisville Apartment Homes in Lewisville, TX. The gallery includes kitchens with granite countertops and stainless steel appliances, the resort-style pool and cabanas, the clubhouse, the 24-hour fitness center, and the on-site bark park.</p><p><br></p><p>Compare our floor plans or schedule a tour to see Cypress at Lewisville in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Find your place in Lewisville.</strong> Use the interactive map to explore available one-, two-, and three-bedroom apartments at Cypress at Lewisville, then see how close you are to everyday shopping, dining, major routes, and nearby outdoor destinations.</p>",
  "property_pets_blurb": "<p>Cypress at Lewisville welcomes dogs and cats, with up to two pets per apartment. Monthly pet rent is $25 per pet. The non-refundable pet fee is $300 for one pet or $500 for two pets.</p><p><br></p><p>Some dog breeds are restricted, including Pit Bulls, American Staffordshire Terriers, Rottweilers, German Shepherds, Malamutes, Doberman Pinschers, Chows, Great Danes, Saint Bernards, Akitas, wolf hybrids, and any mix of these breeds. Exotic, feral, or wild animals are not permitted. Contact our leasing team for complete pet policy details.</p>",
  "property_referafriend_blurb": "<p><strong>Share polished Lewisville living.</strong> Love the upscale finishes, gated setting, resort-style pool, and easy access to daily essentials? Refer a friend to Cypress at Lewisville Apartment Homes and invite them to find their next one-, two-, or three-bedroom home here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access, made easy.</strong><br>Log in to manage your Cypress at Lewisville Apartment Homes account, pay rent, submit maintenance requests, and keep everyday living on track in a polished Lewisville setting connected to what you need.</p>",
  "property_reviews_blurb": "<p><strong>Real feedback, real reasons to love coming home.</strong> Residents consistently praise Cypress at Lewisville Apartment Homes for its responsive staff, peaceful atmosphere, clean community spaces, and well-kept amenities. One longtime resident shared, “I feel just as valued as I did when I walked in,” highlighting the care that continues well beyond move-in day.</p><p>As you browse the reviews, you’ll see repeat mentions of spacious, stylish apartments, convenient access to everyday shopping and dining, a fabulous pool, and fitness offerings residents appreciate. From smooth maintenance experiences to a quiet setting in the Lewisville/Flower Mound area, the reviews tell a clear story: Cypress is a place residents are happy to recommend.</p>",
  "property_created_at": "1785791570184",
  "property_scheduletour_blurb": "<p><strong>See polished Lewisville living up close.</strong> Tour one-, two-, and three-bedroom apartments with granite countertops, stainless steel appliances, spacious closets, and garden tubs—then explore the gated grounds, resort-style pool, clubhouse coffee lounge, and fitness spaces. Schedule your visit today and picture your next home at Cypress at Lewisville.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—your inquiry has been received.</strong><br>Our leasing team will follow up soon. In the meantime, picture polished Lewisville living with upscale one-, two-, and three-bedroom floor plans, beautifully landscaped grounds, and resort-style spaces designed to make everyday life feel easy and connected.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "2026 All Rights Reserved. Cypress at Lewisville Apartment Homes",
  "property_seo_title_home": "Apartments in Lewisville, TX | Cypress at Lewisville",
  "property_seo_description_home": "Tour 1, 2 & 3-bedroom apartments at Cypress at Lewisville Apartment Homes in Lewisville, TX, with a resort-style pool, gym, and attached garages.",
  "property_seo_title_floorplans": "1, 2 & 3-Bed Apartments in Lewisville, TX | Cypress",
  "property_seo_description_floorplans": "Browse 21 floor plans at Cypress at Lewisville Apartment Homes in Lewisville, TX, with one, two, and three-bedroom layouts up to 1,394 sq ft.",
  "property_seo_title_amenities": "Pet-Friendly Apartment Amenities | Cypress Lewisville",
  "property_seo_description_amenities": "See amenities at Cypress at Lewisville Apartment Homes in Lewisville, TX, including a pool, 24-hour gym, bark park, and pet-friendly living.",
  "property_seo_title_gallery": "Photo Gallery | Cypress at Lewisville Apartment Homes",
  "property_seo_description_gallery": "Browse photos of apartment interiors, amenities, and community spaces at Cypress at Lewisville Apartment Homes in Lewisville, TX.",
  "property_seo_title_virtualtours": "Virtual Tours | Cypress at Lewisville Apartments",
  "property_seo_description_virtualtours": "Take a 360 virtual tour of select floor plans at Cypress at Lewisville Apartment Homes in Lewisville, TX before you schedule an in-person visit.",
  "property_seo_title_interactivemap": "Interactive Property Map | Cypress at Lewisville",
  "property_seo_description_interactivemap": "Use the Cypress at Lewisville Apartment Homes interactive property map to explore available apartments and floor plans in Lewisville, TX.",
  "property_seo_title_neighborhood": "Apartments Near Music City Mall | Cypress Lewisville",
  "property_seo_description_neighborhood": "Cypress at Lewisville Apartment Homes sits minutes from Music City Mall, Vista Ridge Plaza, and I-35 E in Lewisville, TX.",
  "property_seo_title_contact": "Contact Cypress at Lewisville Apartment Homes",
  "property_seo_description_contact": "Contact Cypress at Lewisville Apartment Homes in Lewisville, TX to ask about floor plans, pricing, availability, or scheduling a tour.",
  "property_seo_title_faqs": "FAQs | Cypress at Lewisville Apartment Homes",
  "property_seo_description_faqs": "Find answers about applications, pet policies, utilities, and maintenance at Cypress at Lewisville Apartment Homes in Lewisville, TX.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Lewisville, TX",
  "property_seo_description_reviews": "Discover vibrant living at Cypress at Lewisville! Explore resident reviews, captivating amenities, spacious layouts, and a welcoming community.",
  "property_seo_title_applynow": "Apply Now | Apartments in Lewisville, TX",
  "property_seo_description_applynow": "Experience modern living at Cypress at Lewisville! Choose from spacious one, two, or three-bedroom homes with top-notch amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Cypress at Lewisville Apartment Homes",
  "property_seo_description_residentaccess": "Unlock convenience at Cypress at Lewisville! Access your resident portal for easy rent payments, maintenance requests, and community updates—all in one place.",
  "property_seo_title_referafriend": "Refer A Friend | Cypress at Lewisville Apartment Homes",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Cypress at Lewisville Apartment Homes and enjoy a vibrant community in the heart of Texas. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Cypress at Lewisville Apartments",
  "property_seo_description_scheduletour": "Schedule a guided or virtual tour of Cypress at Lewisville Apartment Homes in Lewisville, TX and find your next one, two, or three-bedroom home.",
  "property_seo_title_privacy": "Privacy Policy | Cypress at Lewisville Apartment Homes",
  "property_seo_description_privacy": "Safeguarding your privacy is our top priority at Cypress at Lewisville. Learn how we protect your information and maintain a secure community.",
  "property_seo_title_accessibility": "Website Accessibility | Cypress at Lewisville Apartment Homes",
  "property_seo_description_accessibility": "Experience true accessibility at Cypress at Lewisville Apartment Homes! Our commitment to digital inclusion ensures everyone can enjoy our vibrant community.",
  "property_seo_title_sitemap": "Sitemap | Cypress at Lewisville Apartment Homes",
  "property_seo_description_sitemap": "Navigate your way to luxury living at Cypress at Lewisville! Uncover amenities, floor plans, and everything you need with our detailed sitemap today!",
  "property_seo_title_thankyou": "Thank You | Cypress at Lewisville Apartment Homes",
  "property_seo_description_thankyou": "Thank you for your interest in Cypress at Lewisville! One of our team members will reach out soon to help you find your perfect home in our vibrant community.",
  "property_seo_title_pets": "Pet Policy | Apartments in Lewisville, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793628835132",
  "amenities": [
    {
      "id": "ec_ce04ab320f69364819d4d52b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "yardi",
      "external_id": "87752121",
      "title": "24-Hour State-of-the-art Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01023-b4d6-7309-ac61-52fa1327d44b.webp",
      "amenity_image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, stationary bikes, and free weights.",
        "public_id": "01a01023-b4d6-7309-ac61-52fa1327d44b",
        "storage_key": "property/6767906449167598/01a01023-b4d6-7309-ac61-52fa1327d44b.webp",
        "width": 1900,
        "height": 1267
      },
      "amenity_image_alt_text": "fitness center1 at  Cypress at Lewisville Apartments , Lewisville,Texas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0d1012461dda373aa9e98183",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "yardi",
      "external_id": "87752120",
      "title": "Swimming Pool with Sun Shelf",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01023-bf4f-7572-8099-83745df0e985.webp",
      "amenity_image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and surrounding landscaping.",
        "public_id": "01a01023-bf4f-7572-8099-83745df0e985",
        "storage_key": "property/6767906449167598/01a01023-bf4f-7572-8099-83745df0e985.webp",
        "width": 3072,
        "height": 2047
      },
      "amenity_image_alt_text": "a birds eye view of the pool at Cypress at Lewisville Apartment Homes, Texas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dd231daef96107a63b52d000",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "yardi",
      "external_id": "87752105",
      "title": "Clubhouse with Business Center, Coffee Lounge, Copy & Fax Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01023-b266-771e-969a-a16b2e2c18aa.webp",
      "amenity_image_media": {
        "alt_text": "Clubhouse lounge area with seating, coffee table, and computers.",
        "public_id": "01a01023-b266-771e-969a-a16b2e2c18aa",
        "storage_key": "property/6767906449167598/01a01023-b266-771e-969a-a16b2e2c18aa.webp",
        "width": 1709,
        "height": 1140
      },
      "amenity_image_alt_text": "clubhouse at Cypress at Lewisville Apartments , Lewisville,TX",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_21c22ba64e29d381ea2315a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "yardi",
      "external_id": "87752091",
      "title": "Bark Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01023-ab0a-7718-adb0-dffab88db985.webp",
      "amenity_image_media": {
        "alt_text": "Spacious fenced dog park with green grass and trees, adjacent to apartment buildings.",
        "public_id": "01a01023-ab0a-7718-adb0-dffab88db985",
        "storage_key": "property/6767906449167598/01a01023-ab0a-7718-adb0-dffab88db985.webp",
        "width": 2400,
        "height": 1600
      },
      "amenity_image_alt_text": "Bark Park at  Cypress at Lewisville Apartments Texas , 75067",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ed0a25cf387c76a1252daa09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "yardi",
      "external_id": "87752117",
      "title": "Outdoor Kitchen & Grill, Lounge with Fireplaces & TV",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01023-b65a-74ee-8b5b-f44776fc6204.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor living area with fireplace, seating, and a coffee table, with a pool and buildings in the background.",
        "public_id": "01a01023-b65a-74ee-8b5b-f44776fc6204",
        "storage_key": "property/6767906449167598/01a01023-b65a-74ee-8b5b-f44776fc6204.webp",
        "width": 1900,
        "height": 1267
      },
      "amenity_image_alt_text": "outdoor fireplace and tv at  Cypress at Lewisville Apartments , Lewisville,grill at  Cypress at Lewisville Apartments , Lewisville,Texas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9f6f4e04ab5056fdd47924f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "yardi",
      "external_id": "87769073",
      "title": "Complimentary Fitness Classes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_13b4addc5df2c74da67187c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "yardi",
      "external_id": "87752093",
      "title": "Private Poolside Cabanas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01023-ca52-772c-a8b3-148ea9942fab.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor seating area with a table and chairs overlooking a swimming pool.",
        "public_id": "01a01023-ca52-772c-a8b3-148ea9942fab",
        "storage_key": "property/6767906449167598/01a01023-ca52-772c-a8b3-148ea9942fab.webp",
        "width": 1900,
        "height": 1267
      },
      "amenity_image_alt_text": "poolside view at Cypress at Lewisville Apartments , Lewisville,75067",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a56c5db433f9705db9ecba56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "yardi",
      "external_id": "87752111",
      "title": "Gated/Controlled Access Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d67882cb1c87779ae2ce4889",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "yardi",
      "external_id": "87752069",
      "title": "24-Hour On-call Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_012900ec03dd20038917475e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "yardi",
      "external_id": "87752122",
      "title": "Valet Trash Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_faf8b39b76e593c73b23d131",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "yardi",
      "external_id": "87752072",
      "title": "Breezeway Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_544d23ccfee357318e1598d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "yardi",
      "external_id": "87752087",
      "title": "Visitor Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_323f0f7cb01bdfcb8235ba9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "yardi",
      "external_id": "87752082",
      "title": "Easy Access to Freeways & Shopping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0b62fa83e67d0f0a4920f7df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "yardi",
      "external_id": "87752101",
      "title": "Beautiful Landscaping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01023-c795-7592-bd8e-768e59f84b95.webp",
      "amenity_image_media": {
        "alt_text": "Aerial view of apartment buildings and surrounding landscape.",
        "public_id": "01a01023-c795-7592-bd8e-768e59f84b95",
        "storage_key": "property/6767906449167598/01a01023-c795-7592-bd8e-768e59f84b95.webp",
        "width": 1200,
        "height": 799
      },
      "amenity_image_alt_text": "Drone Community View at Cypress at Lewisville Apartment Homes, Lewisville",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b41f28ee1c747b32089119fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "yardi",
      "external_id": "122169243",
      "title": "Flexible Rent Payment Options",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_85015cf3bd338157621a6976",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "yardi",
      "external_id": "87752134",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_316c234fc1c6bf8f86a3397f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "yardi",
      "external_id": "87752170",
      "title": "Stainless Steel, All Electric Appliance Package",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01023-d0f8-76a8-9afd-424995a7e135.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and island with stovetop.",
        "public_id": "01a01023-d0f8-76a8-9afd-424995a7e135",
        "storage_key": "property/6767906449167598/01a01023-d0f8-76a8-9afd-424995a7e135.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "a kitchen with granite countertops and dark wood cabinets at Cypress at Lewisville Apartment Homes, Texas, 75067",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_08c7182889229b531b6149d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "yardi",
      "external_id": "87752168",
      "title": "Side by Side Fridge with Ice & Water in Door",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3d5e24c4465f986d730cb23b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "yardi",
      "external_id": "87752160",
      "title": "Gourmet Kitchens with Granite Counters & Ceramic Tile Backsplashes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01023-cf61-732b-9261-b7bfc3ced3b4.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with island and stainless steel appliances, open to living room.",
        "public_id": "01a01023-cf61-732b-9261-b7bfc3ced3b4",
        "storage_key": "property/6767906449167598/01a01023-cf61-732b-9261-b7bfc3ced3b4.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A modern kitchen with a bar area and a dining table.at Cypress at Lewisville Apartment Homes, Lewisville, TX",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b03f84086faf2bf80a85ddfc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "yardi",
      "external_id": "87752137",
      "title": "Kitchen Island with Smoothtop Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01023-d5f4-7558-8efc-e177685c1a4f.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with granite countertops and stainless steel appliances.",
        "public_id": "01a01023-d5f4-7558-8efc-e177685c1a4f",
        "storage_key": "property/6767906449167598/01a01023-d5f4-7558-8efc-e177685c1a4f.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A kitchen with granite countertops and a stainless steel refrigerator.at Cypress at Lewisville Apartment Homes, Lewisville, 75067",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d5fd33f7e8c659403d9b9bae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "yardi",
      "external_id": "87752125",
      "title": "Breakfast Bar, Kitchen Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_73534afb7105517309748528",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "yardi",
      "external_id": "87844027",
      "title": "9 ft. Ceilings & Ceiling Fans*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_31e7d9f1f842120ac00b8fec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "yardi",
      "external_id": "87752132",
      "title": "Ceramic Tile Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_58ebd8d9f20e4c028ef07549",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "yardi",
      "external_id": "87752135",
      "title": "Garden Tub",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_44b28304869f9f64ee78386b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "yardi",
      "external_id": "87752149",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c187c3110ed808af514b595d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "yardi",
      "external_id": "87752158",
      "title": "Attached Garage*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01023-e8c6-779b-a065-bd0af6da2d7c.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of apartment building with garages and balconies",
        "public_id": "01a01023-e8c6-779b-a065-bd0af6da2d7c",
        "storage_key": "property/6767906449167598/01a01023-e8c6-779b-a065-bd0af6da2d7c.webp",
        "width": 1900,
        "height": 1267
      },
      "amenity_image_alt_text": "apartment building exterior 2 at  Cypress at Lewisville Apartments, Texas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d06ef19f170db22230ec91c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "yardi",
      "external_id": "87752172",
      "title": "Washer and Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01023-df95-7089-978e-55e2db91dab2.webp",
      "amenity_image_media": {
        "alt_text": "Laundry closet with washer and dryer hookups, water heater, and storage shelf.",
        "public_id": "01a01023-df95-7089-978e-55e2db91dab2",
        "storage_key": "property/6767906449167598/01a01023-df95-7089-978e-55e2db91dab2.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Closet View at Cypress at Lewisville Apartment Homes, Lewisville, TX 75067",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_ae115902baafe18bb8a09b3b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01023-9da5-714b-902b-fd21e45322ee.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a01023-9da5-714b-902b-fd21e45322ee",
        "storage_key": "property/6767906449167598/01a01023-9da5-714b-902b-fd21e45322ee.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim or relax by the pool at our stunning outdoor oasis, complete with ample lounge seating and shaded areas.",
      "link": "false",
      "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/DJI_20240404131947_0316_D.jpg"
    },
    {
      "id": "ec_24c9bc01437c8039277ed4e3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01023-f8b6-737a-bbbd-0a4b20bb47fb.webp",
      "image_media": {
        "alt_text": "Cypress at Lewisville property monument sign with flowers.",
        "public_id": "01a01023-f8b6-737a-bbbd-0a4b20bb47fb",
        "storage_key": "property/6767906449167598/01a01023-f8b6-737a-bbbd-0a4b20bb47fb.webp",
        "width": 1540,
        "height": 1026
      },
      "title": "Community",
      "description": "Welcome to Cypress at Lewisville, a beautiful apartment community with a prominent monument sign, complemented by lush landscaping and vibrant flowers.",
      "link": "false",
      "alt_text": "Cypress at Lewisville property monument sign with flowers.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/image005.jpg"
    },
    {
      "id": "ec_6f5a0c76d57c64919f88f09e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01023-f859-77cf-9d1e-6c375f02c403.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with turquoise chairs and fire pit overlooking a swimming pool and apartment buildings.",
        "public_id": "01a01023-f859-77cf-9d1e-6c375f02c403",
        "storage_key": "property/6767906449167598/01a01023-f859-77cf-9d1e-6c375f02c403.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax by the sparkling pool or gather with friends at the outdoor seating area, complete with comfortable chairs and a fire pit. Enjoy the resort-style amenities at our community.",
      "link": "false",
      "alt_text": "Outdoor seating area with turquoise chairs and fire pit overlooking a swimming pool and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/DSC09648.jpg"
    },
    {
      "id": "ec_00c8782b338de658210afb10",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01023-f6d7-72f8-a922-21a2133d0a3b.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with built-in grill and covered seating areas.",
        "public_id": "01a01023-f6d7-72f8-a922-21a2133d0a3b",
        "storage_key": "property/6767906449167598/01a01023-f6d7-72f8-a922-21a2133d0a3b.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy al fresco dining at our community's outdoor kitchen and lounge spaces, perfect for entertaining guests.",
      "link": "false",
      "alt_text": "Outdoor grilling area with built-in grill and covered seating areas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/10-2436 S Valley Pkwy -14(3).jpg"
    },
    {
      "id": "ec_b091a53ca9d7ea9370f82976",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01023-f6ae-7526-8dcb-3cc0b015036f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and bar stools, open to living area.",
        "public_id": "01a01023-f6ae-7526-8dcb-3cc0b015036f",
        "storage_key": "property/6767906449167598/01a01023-f6ae-7526-8dcb-3cc0b015036f.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring a spacious island with seating, sleek dark cabinetry, and stainless steel appliances. Open-concept design flows seamlessly into the living space.",
      "link": "false",
      "alt_text": "Modern kitchen with island and bar stools, open to living area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/11-2436 S Valley Pkwy -15_final(1).jpg"
    },
    {
      "id": "ec_c04e7a98a22f4aa5a8c1403e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01023-f787-752c-8288-125d8a41bd9e.webp",
      "image_media": {
        "alt_text": "Living room and kitchen in an apartment",
        "public_id": "01a01023-f787-752c-8288-125d8a41bd9e",
        "storage_key": "property/6767906449167598/01a01023-f787-752c-8288-125d8a41bd9e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living room and modern kitchen with island and stainless steel appliances.",
      "link": "false",
      "alt_text": "Living room and kitchen in an apartment",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/19-2436 S Valley Pkwy -19_final.jpg"
    },
    {
      "id": "ec_8f3c1934222992b2c3e00734",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-0548-74af-9501-d85286229f57.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "01a01024-0548-74af-9501-d85286229f57",
        "storage_key": "property/6767906449167598/01a01024-0548-74af-9501-d85286229f57.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Discover a chef's dream kitchen featuring sleek dark cabinetry, elegant granite countertops, and a full suite of modern stainless steel appliances, perfect for culinary adventures.",
      "link": "false",
      "alt_text": "Modern kitchen with dark cabinets, granite countertops, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/13-2436 S Valley Pkwy -16(2).jpg"
    },
    {
      "id": "ec_9e034df2784f8a336dacf7d6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-0613-72fb-92ff-c13f214ce26d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a large island with seating.",
        "public_id": "01a01024-0613-72fb-92ff-c13f214ce26d",
        "storage_key": "property/6767906449167598/01a01024-0613-72fb-92ff-c13f214ce26d.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Discover the perfect blend of style and functionality in this beautifully appointed apartment kitchen, featuring sleek cabinetry, premium appliances, and a spacious island for dining and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and a large island with seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/48-2436 S Valley Pkwy -36_final.jpg"
    },
    {
      "id": "ec_0d39453bf690eabdaed83fe4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-05a2-701c-b406-a2e9b5469e64.webp",
      "image_media": {
        "alt_text": "Living room with brown sofa and adjacent kitchen.",
        "public_id": "01a01024-05a2-701c-b406-a2e9b5469e64",
        "storage_key": "property/6767906449167598/01a01024-05a2-701c-b406-a2e9b5469e64.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable brown sofa with white accent pillows, adjacent to a modern kitchen with dark cabinetry and granite countertops.",
      "link": "false",
      "alt_text": "Living room with brown sofa and adjacent kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/59-2436 S Valley Pkwy -55.jpg"
    },
    {
      "id": "ec_44f6a7636c9242f4c76b1a83",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-09e3-742f-bacb-b0df65d6fb4d.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, dresser, and mirror, leading to a bathroom.",
        "public_id": "01a01024-09e3-742f-bacb-b0df65d6fb4d",
        "storage_key": "property/6767906449167598/01a01024-09e3-742f-bacb-b0df65d6fb4d.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, a stylish dresser, and a full-length mirror. The adjacent bathroom is visible through the doorway.",
      "link": "false",
      "alt_text": "Bedroom with a large bed, dresser, and mirror, leading to a bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/60-2436 S Valley Pkwy -44.jpg"
    },
    {
      "id": "ec_182e44c0342995ac9136d144",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-0cb6-71c8-9c9e-61579466633f.webp",
      "image_media": {
        "alt_text": "Spacious living room and kitchen area with modern furnishings.",
        "public_id": "01a01024-0cb6-71c8-9c9e-61579466633f",
        "storage_key": "property/6767906449167598/01a01024-0cb6-71c8-9c9e-61579466633f.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A beautifully appointed living room flows seamlessly into a modern kitchen, perfect for entertaining and everyday living.",
      "link": "false",
      "alt_text": "Spacious living room and kitchen area with modern furnishings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/21-2436 S Valley Pkwy -20_final.jpg"
    },
    {
      "id": "ec_c4c757688a3826576ca1cf6b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-12f4-730b-8a3c-7bc74173fb8a.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-sized bed, ceiling fan, and access to a bathroom.",
        "public_id": "01a01024-12f4-730b-8a3c-7bc74173fb8a",
        "storage_key": "property/6767906449167598/01a01024-12f4-730b-8a3c-7bc74173fb8a.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-sized bed, a modern ceiling fan, and convenient access to the en-suite bathroom. Experience ultimate relaxation and comfort in this well-appointed living space.",
      "link": "false",
      "alt_text": "Bedroom with a king-sized bed, ceiling fan, and access to a bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/39-2436 S Valley Pkwy -27_final.jpg"
    },
    {
      "id": "ec_8bffb24d058f229a20922ac1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-12f4-730b-8a3c-7c47f5c94e19.webp",
      "image_media": {
        "alt_text": "Bright living room with a white sofa, coffee table, and balcony doors.",
        "public_id": "01a01024-12f4-730b-8a3c-7c47f5c94e19",
        "storage_key": "property/6767906449167598/01a01024-12f4-730b-8a3c-7c47f5c94e19.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious and inviting living room featuring a comfortable white sofa, a stylish marble coffee table, and large balcony doors that let in natural light.",
      "link": "false",
      "alt_text": "Bright living room with a white sofa, coffee table, and balcony doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/15-2436 S Valley Pkwy -17_final.jpg"
    },
    {
      "id": "ec_f1cff76d5212d48d2714e54b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-1411-76ec-851a-b3496507a5cf.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, ceiling fan, and access to a bathroom and kitchen.",
        "public_id": "01a01024-1411-76ec-851a-b3496507a5cf",
        "storage_key": "property/6767906449167598/01a01024-1411-76ec-851a-b3496507a5cf.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, modern ceiling fan, and ample natural light. Enjoy easy access to the en-suite bathroom and a glimpse of the kitchen area.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, ceiling fan, and access to a bathroom and kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/41-2436 S Valley Pkwy -28_final.jpg"
    },
    {
      "id": "ec_7a36b4342dd07df036ec6d11",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-1570-7792-a767-e8e051987267.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, a TV, and an en suite bathroom visible.",
        "public_id": "01a01024-1570-7792-a767-e8e051987267",
        "storage_key": "property/6767906449167598/01a01024-1570-7792-a767-e8e051987267.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, a modern entertainment center with a large TV, and convenient access to an en suite bathroom.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, a TV, and an en suite bathroom visible.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/34-2436 S Valley Pkwy -40_final.jpg"
    },
    {
      "id": "ec_7b8fc1451369ab0709a4b68f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-1856-72ea-a7eb-d3f524a36807.webp",
      "image_media": {
        "alt_text": "Walk-in closet with organized clothes and shelving.",
        "public_id": "01a01024-1856-72ea-a7eb-d3f524a36807",
        "storage_key": "property/6767906449167598/01a01024-1856-72ea-a7eb-d3f524a36807.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample shelving and hanging space for all your clothing needs.",
      "link": "false",
      "alt_text": "Walk-in closet with organized clothes and shelving.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/30-2436 S Valley Pkwy -25_final.jpg"
    },
    {
      "id": "ec_5c823c61d405606a33625c72",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-2002-75a3-8233-73892f008702.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, ceiling fan, and dresser by the window.",
        "public_id": "01a01024-2002-75a3-8233-73892f008702",
        "storage_key": "property/6767906449167598/01a01024-2002-75a3-8233-73892f008702.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, a modern ceiling fan, and ample storage with a dresser by the window.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, ceiling fan, and dresser by the window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/61-2436 S Valley Pkwy -45.jpg"
    },
    {
      "id": "ec_5709815e26e0076f3ee67d31",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-20df-77aa-8fba-4be3549c0ebf.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and a large island.",
        "public_id": "01a01024-20df-77aa-8fba-4be3549c0ebf",
        "storage_key": "property/6767906449167598/01a01024-20df-77aa-8fba-4be3549c0ebf.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring dark wood cabinetry, granite countertops, stainless steel appliances, and a central island perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and a large island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/14-2436 S Valley Pkwy -32.jpg"
    },
    {
      "id": "ec_7c8a2765bb9974a6ba5bd365",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-21bc-7233-9dfd-37fd7979210c.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, shower, and walk-in closet.",
        "public_id": "01a01024-21bc-7233-9dfd-37fd7979210c",
        "storage_key": "property/6767906449167598/01a01024-21bc-7233-9dfd-37fd7979210c.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a granite-top vanity with dark cabinetry, a walk-in closet, and a glass-enclosed shower.",
      "link": "false",
      "alt_text": "Bathroom with vanity, shower, and walk-in closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/29-2436 S Valley Pkwy -24_final.jpg"
    },
    {
      "id": "ec_f456dcf389f10429a178c554",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-22e5-7661-8cad-0633b8e8b124.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, nightstand, and dresser.",
        "public_id": "01a01024-22e5-7661-8cad-0633b8e8b124",
        "storage_key": "property/6767906449167598/01a01024-22e5-7661-8cad-0633b8e8b124.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, stylish nightstand, and a decorative dresser, creating a serene living space.",
      "link": "false",
      "alt_text": "Bedroom with a bed, nightstand, and dresser.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/66-2436 S Valley Pkwy -50.jpg"
    },
    {
      "id": "ec_e2bc98205eb41bef620553cd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-26cf-727f-881a-20b91b951e49.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, and a ceiling fan.",
        "public_id": "01a01024-26cf-727f-881a-20b91b951e49",
        "storage_key": "property/6767906449167598/01a01024-26cf-727f-881a-20b91b951e49.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Comfortable and stylish bedroom featuring a queen-size bed, soft linens, ambient lighting, and a ceiling fan for optimal comfort. This inviting space is perfect for relaxation.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, nightstands, and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/37-2436 S Valley Pkwy -26_final.jpg"
    },
    {
      "id": "ec_b349641cf6f1a217eb7cf16d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-2df8-77fa-8e51-86423bd1589e.webp",
      "image_media": {
        "alt_text": "Living room with a tv and open kitchen concept.",
        "public_id": "01a01024-2df8-77fa-8e51-86423bd1589e",
        "storage_key": "property/6767906449167598/01a01024-2df8-77fa-8e51-86423bd1589e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living room with a large TV and an open-concept kitchen featuring a breakfast bar.",
      "link": "false",
      "alt_text": "Living room with a tv and open kitchen concept.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/53-2436 S Valley Pkwy -38_final.jpg"
    },
    {
      "id": "ec_4ef55538e76a0d0108b23ceb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-2ead-723f-9348-7e8cfa7dda98.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, ceiling fan, and modern decor.",
        "public_id": "01a01024-2ead-723f-9348-7e8cfa7dda98",
        "storage_key": "property/6767906449167598/01a01024-2ead-723f-9348-7e8cfa7dda98.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a plush king-size bed, stylish accent art, and a ceiling fan for comfort. Perfect for a restful retreat.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, ceiling fan, and modern decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/32-2436 S Valley Pkwy -39_final(1).jpg"
    },
    {
      "id": "ec_69706df32daa5fa2037fb919",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-2f86-7678-88aa-7e46d3067651.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with granite countertop and large mirror, next to a bedroom.",
        "public_id": "01a01024-2f86-7678-88aa-7e46d3067651",
        "storage_key": "property/6767906449167598/01a01024-2f86-7678-88aa-7e46d3067651.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Chic bathroom featuring a dark wood vanity, granite countertop, and spacious mirror. View the adjacent bedroom for a complete apartment tour.",
      "link": "false",
      "alt_text": "Modern bathroom vanity with granite countertop and large mirror, next to a bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/68-2436 S Valley Pkwy -53.jpg"
    },
    {
      "id": "ec_29e88b5d91545be7f17bdd25",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-3298-73c9-b69e-163a510e9dae.webp",
      "image_media": {
        "alt_text": "Modern living room with a white couch, marble coffee table, and TV stand.",
        "public_id": "01a01024-3298-73c9-b69e-163a510e9dae",
        "storage_key": "property/6767906449167598/01a01024-3298-73c9-b69e-163a510e9dae.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A stylish and spacious living room featuring a comfortable white sofa, elegant marble coffee table, and a sleek black TV stand, perfect for relaxation and entertainment.",
      "link": "false",
      "alt_text": "Modern living room with a white couch, marble coffee table, and TV stand.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/17-2436 S Valley Pkwy -18_final.jpg"
    },
    {
      "id": "ec_d2e6601f93a4a594bf09026d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-34e6-76ee-8a33-512583e12088.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite island and stainless steel appliances.",
        "public_id": "01a01024-34e6-76ee-8a33-512583e12088",
        "storage_key": "property/6767906449167598/01a01024-34e6-76ee-8a33-512583e12088.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious apartment kitchen featuring a large granite island with a built-in stovetop, stainless steel appliances, and dark wood cabinetry.",
      "link": "false",
      "alt_text": "Modern kitchen with granite island and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/49-2436 S Valley Pkwy -36.jpg"
    },
    {
      "id": "ec_1e3e1ab3771f5c93af503e38",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-38fd-7278-aa9a-a8d103cebc08.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan, dresser, and view into kitchen and bathroom.",
        "public_id": "01a01024-38fd-7278-aa9a-a8d103cebc08",
        "storage_key": "property/6767906449167598/01a01024-38fd-7278-aa9a-a8d103cebc08.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, stylish dresser with artwork, and views into the kitchen and bathroom.",
      "link": "false",
      "alt_text": "Bedroom with ceiling fan, dresser, and view into kitchen and bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/27-2436 S Valley Pkwy -23_final.jpg"
    },
    {
      "id": "ec_dac8265533ee8afa54441579",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-3a72-709a-bfd8-a2a35142d165.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, entertainment center, and TV.",
        "public_id": "01a01024-3a72-709a-bfd8-a2a35142d165",
        "storage_key": "property/6767906449167598/01a01024-3a72-709a-bfd8-a2a35142d165.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable sectional sofa, modern coffee table, and a sleek entertainment center with a large flat-screen TV.",
      "link": "false",
      "alt_text": "Living room with a sectional sofa, coffee table, entertainment center, and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/51-2436 S Valley Pkwy -37_final.jpg"
    },
    {
      "id": "ec_21098d0a134916ba3bff6c1a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-3b99-7693-bf5d-76795b23060a.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, ceiling fan, and decorative mirror.",
        "public_id": "01a01024-3b99-7693-bf5d-76795b23060a",
        "storage_key": "property/6767906449167598/01a01024-3b99-7693-bf5d-76795b23060a.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, a modern ceiling fan, and elegant decor. Enjoy a relaxing retreat in this well-appointed apartment.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, ceiling fan, and decorative mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/65-2436 S Valley Pkwy -51.jpg"
    },
    {
      "id": "ec_da53fe9e712cf4e871191b44",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-3d9e-779d-825a-0d7f5088c9dd.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a walk-in shower, vanity with granite countertop, and a closet.",
        "public_id": "01a01024-3d9e-779d-825a-0d7f5088c9dd",
        "storage_key": "property/6767906449167598/01a01024-3d9e-779d-825a-0d7f5088c9dd.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience luxury in this beautifully appointed bathroom featuring a spacious walk-in shower, elegant granite countertops, and ample closet space for all your storage needs.",
      "link": "false",
      "alt_text": "Modern bathroom with a walk-in shower, vanity with granite countertop, and a closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/69-2436 S Valley Pkwy -54.jpg"
    },
    {
      "id": "ec_8d377f64c633df41f26cbe8d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-3f14-7194-b630-cbdbd02a8999.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with a view into a bedroom.",
        "public_id": "01a01024-3f14-7194-b630-cbdbd02a8999",
        "storage_key": "property/6767906449167598/01a01024-3f14-7194-b630-cbdbd02a8999.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment kitchen featuring granite countertops, stainless steel appliances, and a large island. The dining area offers a glass-top table with comfortable seating.",
      "link": "false",
      "alt_text": "Modern kitchen and dining area with a view into a bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/57-2436 S Valley Pkwy -49.jpg"
    },
    {
      "id": "ec_f6e7448519f68eff1a4ff00e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-42a1-7379-a62a-db3ce6d4ca9e.webp",
      "image_media": {
        "alt_text": "Bedroom with king-size bed, nightstands, ceiling fan, and artwork.",
        "public_id": "01a01024-42a1-7379-a62a-db3ce6d4ca9e",
        "storage_key": "property/6767906449167598/01a01024-42a1-7379-a62a-db3ce6d4ca9e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed bedroom, featuring a comfortable king-size bed, elegant nightstands, a soothing ceiling fan, and stylish wall art. A perfect retreat.",
      "link": "false",
      "alt_text": "Bedroom with king-size bed, nightstands, ceiling fan, and artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/25-2436 S Valley Pkwy -22_final.jpg"
    },
    {
      "id": "ec_cdd2acf65df9cfb7f6db6bb0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-4623-7123-8cf7-4bdba8d63e14.webp",
      "image_media": {
        "alt_text": "View from balcony of apartment building exterior with surrounding trees and blue sky.",
        "public_id": "01a01024-4623-7123-8cf7-4bdba8d63e14",
        "storage_key": "property/6767906449167598/01a01024-4623-7123-8cf7-4bdba8d63e14.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy the outdoors from your private balcony, offering a scenic view of the surrounding lush greenery and the apartment building's attractive exterior.",
      "link": "false",
      "alt_text": "View from balcony of apartment building exterior with surrounding trees and blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/47-2436 S Valley Pkwy -34(1).jpg"
    },
    {
      "id": "ec_cfe3ba85f06d7236b2ff18ce",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-4c53-75ee-83a9-a022873d4fbc.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines, exercise balls, and TRX suspension trainer.",
        "public_id": "01a01024-4c53-75ee-83a9-a022873d4fbc",
        "storage_key": "property/6767906449167598/01a01024-4c53-75ee-83a9-a022873d4fbc.webp",
        "width": 1855,
        "height": 1237
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring state-of-the-art weight machines, free weights, and cardio equipment. Perfect for your daily workout routine.",
      "link": "false",
      "alt_text": "Fitness center with weight machines, exercise balls, and TRX suspension trainer.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/IMG_8826.jpg"
    },
    {
      "id": "ec_c1a771f3b55ee9d292e3f879",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01023-b4d6-7309-ac61-52fa1327d44b.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, stationary bikes, and free weights.",
        "public_id": "01a01023-b4d6-7309-ac61-52fa1327d44b",
        "storage_key": "property/6767906449167598/01a01023-b4d6-7309-ac61-52fa1327d44b.webp",
        "width": 1900,
        "height": 1267
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring a wide range of cardio machines and free weights for a complete workout.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, ellipticals, stationary bikes, and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/IMG_8823.jpg"
    },
    {
      "id": "ec_28311eb92fbff9e4d60a9950",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-51cc-72ca-a661-5fdf74d0ae7e.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical machines, and weight machines.",
        "public_id": "01a01024-51cc-72ca-a661-5fdf74d0ae7e",
        "storage_key": "property/6767906449167598/01a01024-51cc-72ca-a661-5fdf74d0ae7e.webp",
        "width": 1872,
        "height": 1248
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center features a variety of cardio and strength training equipment to help you stay active and healthy.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, elliptical machines, and weight machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/IMG_8821.jpg"
    },
    {
      "id": "ec_79789068b4b2765e67b77b8a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-4b21-717c-b30f-91c673289aa5.webp",
      "image_media": {
        "alt_text": "Covered outdoor seating area with tables and chairs next to a pool and grill station.",
        "public_id": "01a01024-4b21-717c-b30f-91c673289aa5",
        "storage_key": "property/6767906449167598/01a01024-4b21-717c-b30f-91c673289aa5.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy our outdoor lounge area with comfortable seating, tables, and grills, perfect for relaxing by the pool.",
      "link": "false",
      "alt_text": "Covered outdoor seating area with tables and chairs next to a pool and grill station.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/DSC09594.jpg"
    },
    {
      "id": "ec_d9812fdf9c90eca95f9b3ab5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-5039-7628-accc-2d76ce5096b3.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and surrounding neighborhood",
        "public_id": "01a01024-5039-7628-accc-2d76ce5096b3",
        "storage_key": "property/6767906449167598/01a01024-5039-7628-accc-2d76ce5096b3.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Expansive aerial view showcasing the apartment complex, its surrounding green spaces, and the nearby urban infrastructure including roads, commercial buildings, and a water tower.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings and surrounding neighborhood",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/02-2436 S Valley Pkwy -4(1).jpg"
    },
    {
      "id": "ec_4a1f6a505a331fb5d452fd84",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-53bc-75ad-82bd-1f4968e0ada8.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with surrounding green space and distant urban development.",
        "public_id": "01a01024-53bc-75ad-82bd-1f4968e0ada8",
        "storage_key": "property/6767906449167598/01a01024-53bc-75ad-82bd-1f4968e0ada8.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Experience modern living in this expansive apartment complex, featuring beautifully designed buildings nestled within lush landscaping and offering convenient access to nearby amenities.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings with surrounding green space and distant urban development.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-2436 S Valley Pkwy -2(1).jpg"
    },
    {
      "id": "ec_a1f5170a07fbf24c3148c26a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-59d9-729b-9fb1-e97ad455678f.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with chaise lounges and cabanas by the pool.",
        "public_id": "01a01024-59d9-729b-9fb1-e97ad455678f",
        "storage_key": "property/6767906449167598/01a01024-59d9-729b-9fb1-e97ad455678f.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax and unwind in our resort-style outdoor lounge area, complete with comfortable chaise lounges and shaded cabanas, perfect for enjoying a sunny day.",
      "link": "false",
      "alt_text": "Outdoor lounge area with chaise lounges and cabanas by the pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/DSC09558.jpg"
    },
    {
      "id": "ec_3ac47f3edb164961cde96ca7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-5e19-728c-8161-78d51786e56e.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a covered patio.",
        "public_id": "01a01024-5e19-728c-8161-78d51786e56e",
        "storage_key": "property/6767906449167598/01a01024-5e19-728c-8161-78d51786e56e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy our stunning resort-style swimming pool, complete with comfortable lounge chairs and a shaded, covered patio perfect for relaxing on sunny days.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and a covered patio.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/DSC09843.jpg"
    },
    {
      "id": "ec_abdec8ab1b9aadfdbc7ed03e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-60fe-72e7-85fc-17e04a0b36e8.webp",
      "image_media": {
        "alt_text": "Outdoor living space with fireplace, TV, and seating overlooking a pool area.",
        "public_id": "01a01024-60fe-72e7-85fc-17e04a0b36e8",
        "storage_key": "property/6767906449167598/01a01024-60fe-72e7-85fc-17e04a0b36e8.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Enjoy relaxing outdoors in this inviting space featuring a fireplace, television, and comfortable seating, with a pool area visible in the background.",
      "link": "false",
      "alt_text": "Outdoor living space with fireplace, TV, and seating overlooking a pool area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/DSC09505.jpg"
    },
    {
      "id": "ec_60497a9e80a4284f5cffc33e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-641e-760d-bbf8-697c48e077c4.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and a pond.",
        "public_id": "01a01024-641e-760d-bbf8-697c48e077c4",
        "storage_key": "property/6767906449167598/01a01024-641e-760d-bbf8-697c48e077c4.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Expansive aerial view showcasing the apartment complex with multiple buildings, lush green landscaping, and a serene pond.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings and a pond.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/03-2436 S Valley Pkwy -6(1).jpg"
    },
    {
      "id": "ec_d7e64a270cc41a808ebd2e8c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-670d-766a-8675-ffa4f8e86cf1.webp",
      "image_media": {
        "alt_text": "Aerial view of a luxury apartment complex pool area with lounge chairs and a covered seating area.",
        "public_id": "01a01024-670d-766a-8675-ffa4f8e86cf1",
        "storage_key": "property/6767906449167598/01a01024-670d-766a-8675-ffa4f8e86cf1.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Community",
      "description": "Enjoy our resort-style swimming pool and outdoor lounge areas, perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Aerial view of a luxury apartment complex pool area with lounge chairs and a covered seating area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/DJI_20240404132213_0332_D.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_2eb3767e-8e2b-4099-ba8d-43d7b660b451",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Taqueria Monterrey",
      "poi_type": "Restaurants",
      "poi_address": "1598 S Valley Pkwy, Lewisville, TX 75067, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01017-f4b7-736f-8132-db39b4652bb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-f4b7-736f-8132-db39b4652bb1",
        "storage_key": "property/6767906449167598/01a01017-f4b7-736f-8132-db39b4652bb1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3485079106863800731&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taqueria-monterrey",
      "poi_latitude": "33.0283213",
      "poi_longitude": "-97.019523",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 214-412-5265",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-40a0-7768-a5a9-fc95bb550e89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-40a0-7768-a5a9-fc95bb550e89",
        "storage_key": "property/6767906449167598/019fc979-40a0-7768-a5a9-fc95bb550e89.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOyj1WAAtTIYRm6HAovt8XTA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_11b5c253-2c6d-46a9-b0ef-ea80adb9c611",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Bahama Buck's - Lewisville",
      "poi_type": "Restaurants",
      "poi_address": "2320 S Valley Pkwy, Lewisville, TX 75067, USA",
      "poi_short_description": "Chain with a laid-back, island vibe doling out shaved-ice desserts & smoothies.",
      "poi_long_description": "Chain with a laid-back, island vibe doling out shaved-ice desserts & smoothies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019ff6b8-4f90-70d9-8a6d-519ee7eaec56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b8-4f90-70d9-8a6d-519ee7eaec56",
        "storage_key": "property/6767906449167598/019ff6b8-4f90-70d9-8a6d-519ee7eaec56.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bahamabucks.com/shop/lewisville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1840243995160086944&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bahama-bucks---lewisville",
      "poi_latitude": "33.007413",
      "poi_longitude": "-97.0197925",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 972-459-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-40b9-7005-b89c-ac6cebf333e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-40b9-7005-b89c-ac6cebf333e8",
        "storage_key": "property/6767906449167598/019fc979-40b9-7005-b89c-ac6cebf333e8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ4XGiUDAsTIYRoAmQ3ynciRk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dessert_shop"
    },
    {
      "id": "custom_ace585d4-1fc2-4537-959b-c5a753f67dcc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "The Great Greek Mediterranean Grill - Lewisville, TX",
      "poi_type": "Restaurants",
      "poi_address": "1079 W Round Grove Rd Suite 140, Lewisville, TX 75067, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-1225-77eb-9782-4e0b43a88880.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-1225-77eb-9782-4e0b43a88880",
        "storage_key": "property/6767906449167598/019fc97c-1225-77eb-9782-4e0b43a88880.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.thegreatgreekgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4400619664463386997&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-great-greek-mediterranean-grill---lewisville-tx",
      "poi_latitude": "33.0063824",
      "poi_longitude": "-97.0171051",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 469-884-7328",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-40a0-7768-a5a9-fc95bb550e89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-40a0-7768-a5a9-fc95bb550e89",
        "storage_key": "property/6767906449167598/019fc979-40a0-7768-a5a9-fc95bb550e89.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJaeJeWKEtTIYRdVnw80QkEj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "greek_restaurant"
    },
    {
      "id": "custom_6e7cb841-f7de-4f5c-a758-b696cf80c2c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Marco's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "1490 Valley Ridge Blvd #100, Lewisville, TX 75077, USA",
      "poi_short_description": "Counter-serve chain serving up a menu of specialty or custom pizzas for takeout or delivery.",
      "poi_long_description": "Counter-serve chain serving up a menu of specialty or custom pizzas for takeout or delivery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01017-f51a-7049-85d1-860c313b4ecc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-f51a-7049-85d1-860c313b4ecc",
        "storage_key": "property/6767906449167598/01a01017-f51a-7049-85d1-860c313b4ecc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.marcos.com/our-locations/restaurants/tx/lewisville/marcos-pizza-valley-ridge-blvd-lewisville-1/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8166493699447710102&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marcos-pizza",
      "poi_latitude": "33.062996",
      "poi_longitude": "-97.034366",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-353-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-40a0-7768-a5a9-fc95bb550e89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-40a0-7768-a5a9-fc95bb550e89",
        "storage_key": "property/6767906449167598/019fc979-40a0-7768-a5a9-fc95bb550e89.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ5D4Y3YyTIYRluELcMA2VXE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_c9e2f9fa-3a40-42d6-b596-27a532c046de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Prairie House Restaurant-Lewisville",
      "poi_type": "Restaurants",
      "poi_address": "119 E Main St, Lewisville, TX 75057, USA",
      "poi_short_description": "Updated steakhouse dining & full bar in a rustic-chic space inside a former feed mill from 1886.",
      "poi_long_description": "Updated steakhouse dining & full bar in a rustic-chic space inside a former feed mill from 1886.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019ff6b8-5af9-73ec-9da0-db267088370f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b8-5af9-73ec-9da0-db267088370f",
        "storage_key": "property/6767906449167598/019ff6b8-5af9-73ec-9da0-db267088370f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://phtexaslewisville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6307053305945780996&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prairie-house-restaurant-lewisville",
      "poi_latitude": "33.0466054",
      "poi_longitude": "-96.9932381",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-537-5547",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-40a0-7768-a5a9-fc95bb550e89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-40a0-7768-a5a9-fc95bb550e89",
        "storage_key": "property/6767906449167598/019fc979-40a0-7768-a5a9-fc95bb550e89.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJr0CAhBEuTIYRBPNZyJAnh1c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_2cd79795-dcfb-48b5-b9c5-370d401e0d24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "D'Nonna",
      "poi_type": "Restaurants",
      "poi_address": "233 W Church St, Lewisville, TX 75057, USA",
      "poi_short_description": "Casual eatery for pizza chicken dishes and pasta dishes, served amid cozy Italian decor.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019ff6b8-4818-71a8-8444-89afd8f4c055.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b8-4818-71a8-8444-89afd8f4c055",
        "storage_key": "property/6767906449167598/019ff6b8-4818-71a8-8444-89afd8f4c055.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://dnonnastx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6484643457619944022&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dnonna",
      "poi_latitude": "33.0474803",
      "poi_longitude": "-96.9971419",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 469-240-0008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-40a0-7768-a5a9-fc95bb550e89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-40a0-7768-a5a9-fc95bb550e89",
        "storage_key": "property/6767906449167598/019fc979-40a0-7768-a5a9-fc95bb550e89.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0eYviusvTIYRVmJ_Gt4U_lk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_aba029b3-266c-47f9-aaf8-ba97e786becf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Sullivan Old Town BBQ",
      "poi_type": "Restaurants",
      "poi_address": "301 S Mill St, Lewisville, TX 75057, USA",
      "poi_short_description": "Homey, old-school eatery offering BBQ meat plates & sandwiches, plus regular live entertainment.",
      "poi_long_description": "Homey, old-school eatery offering BBQ meat plates & sandwiches, plus regular live entertainment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019ff6b8-5445-733f-a21e-c015369811ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b8-5445-733f-a21e-c015369811ff",
        "storage_key": "property/6767906449167598/019ff6b8-5445-733f-a21e-c015369811ff.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://sullivanbarbecue.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=959519668941873688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sullivan-old-town-bbq",
      "poi_latitude": "33.0440961",
      "poi_longitude": "-96.9944511",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 469-451-5599",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-40a0-7768-a5a9-fc95bb550e89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-40a0-7768-a5a9-fc95bb550e89",
        "storage_key": "property/6767906449167598/019fc979-40a0-7768-a5a9-fc95bb550e89.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJv8DEmw0vTIYRGOJHHg7mUA0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_77ed220b-cea9-4672-89e5-d6833657bb65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Arepas Street",
      "poi_type": "Restaurants",
      "poi_address": "190 W Main St #108, Lewisville, TX 75057, USA",
      "poi_short_description": "Venezuelan comfort food such as cachapas is served up in a casual atmosphere.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019ff6b8-48e8-70ec-b2d6-ad60ee51078f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b8-48e8-70ec-b2d6-ad60ee51078f",
        "storage_key": "property/6767906449167598/019ff6b8-48e8-70ec-b2d6-ad60ee51078f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://arepasstreet.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=707083101358119175&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arepas-street",
      "poi_latitude": "33.0459544",
      "poi_longitude": "-96.9963524",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 682-365-6981",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-40a0-7768-a5a9-fc95bb550e89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-40a0-7768-a5a9-fc95bb550e89",
        "storage_key": "property/6767906449167598/019fc979-40a0-7768-a5a9-fc95bb550e89.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRZjn3_kvTIYRB9khm1UQ0Ak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_32e70ec6-2970-4ef1-92b5-f58ef1a72ada",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Seven Mile Cafe",
      "poi_type": "Restaurants",
      "poi_address": "201 W Church St, Lewisville, TX 75057, USA",
      "poi_short_description": "Modern restaurant for pancakes and waffles, plus burgers, salads and chicken sandwiches, in cozy digs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-2680-75c2-ae0a-196be100e1ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-2680-75c2-ae0a-196be100e1ef",
        "storage_key": "property/6767906449167598/019fc97c-2680-75c2-ae0a-196be100e1ef.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sevenmilecafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7030752155365641576&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seven-mile-cafe",
      "poi_latitude": "33.0474998",
      "poi_longitude": "-96.9968873",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 469-444-7055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-40a0-7768-a5a9-fc95bb550e89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-40a0-7768-a5a9-fc95bb550e89",
        "storage_key": "property/6767906449167598/019fc979-40a0-7768-a5a9-fc95bb550e89.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEUC7YK0vTIYRaI1htNU_kmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ba389e98-b6ee-4dca-ad82-e24b4624a0da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Irene's Bakery",
      "poi_type": "Restaurants",
      "poi_address": "116 W Main St, Lewisville, TX 75057, USA",
      "poi_short_description": "Baker emphasizing creative wedding & special occasion cakes, plus cupcakes, in a variety of flavors.",
      "poi_long_description": "Baker emphasizing creative wedding & special occasion cakes, plus cupcakes, in a variety of flavors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01017-f3d7-722b-9d65-ab4524985ad9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-f3d7-722b-9d65-ab4524985ad9",
        "storage_key": "property/6767906449167598/01a01017-f3d7-722b-9d65-ab4524985ad9.webp",
        "width": 967,
        "height": 1280
      },
      "poi_business_url": "https://irenesbakery.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7454183885921217904&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "irenes-bakery",
      "poi_latitude": "33.046154",
      "poi_longitude": "-96.9944585",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 214-458-6714",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-40a0-7768-a5a9-fc95bb550e89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-40a0-7768-a5a9-fc95bb550e89",
        "storage_key": "property/6767906449167598/019fc979-40a0-7768-a5a9-fc95bb550e89.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJe--m9BEuTIYRcG3GEsCUcmc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_260a3bf2-d93f-4b66-a9cf-8502ad9c68c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "The Perc Coffeehouse",
      "poi_type": "Restaurants",
      "poi_address": "115 W Main St, Lewisville, TX 75057, USA",
      "poi_short_description": "Vintage-style coffee bar featuring a variety of brews and seating options for relaxing or working.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01018-1b86-778b-ad51-1519f5342bd6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01018-1b86-778b-ad51-1519f5342bd6",
        "storage_key": "property/6767906449167598/01a01018-1b86-778b-ad51-1519f5342bd6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://perccoffeehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8795058376035569102&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-perc-coffeehouse",
      "poi_latitude": "33.046461",
      "poi_longitude": "-96.994644",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 214-222-1404",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019ff6b9-18d9-7648-8f2a-dc06e9fbbd09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6b9-18d9-7648-8f2a-dc06e9fbbd09",
        "storage_key": "property/6767906449167598/019ff6b9-18d9-7648-8f2a-dc06e9fbbd09.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJy1vijBEuTIYRzo1sqv5SDno",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_c4b89ab3-c1d8-4f61-80a4-49b0ab0b13b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Old Town Wine House",
      "poi_type": "Restaurants",
      "poi_address": "119 W Main St, Lewisville, TX 75067, USA",
      "poi_short_description": "Cozy wine bar offering flights, snacks, and mains, plus a patio and live entertainment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01017-f5e9-75fa-bf07-0fa343e7e7ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-f5e9-75fa-bf07-0fa343e7e7ca",
        "storage_key": "property/6767906449167598/01a01017-f5e9-75fa-bf07-0fa343e7e7ca.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://oldtownwinehouseandgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8869014269694380337&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-town-wine-house",
      "poi_latitude": "33.0464586",
      "poi_longitude": "-96.9947034",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 214-222-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01018-23ba-7754-a08b-1402e26a744b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01018-23ba-7754-a08b-1402e26a744b",
        "storage_key": "property/6767906449167598/01a01018-23ba-7754-a08b-1402e26a744b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmWPYjBEuTIYRMQkB_XwRFXs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wine_bar"
    },
    {
      "id": "custom_fab1f9b0-89f7-4235-b927-e732f6c46efc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "State 28 Kitchen & Cocktails",
      "poi_type": "Restaurants",
      "poi_address": "165 W Main St, Lewisville, TX 75057, USA",
      "poi_short_description": "Relaxed restaurant serving comfort food such as brisket grilled cheese and Cajun shrimp pasta.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01017-f6b4-74dc-a79f-efd1349ad622.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-f6b4-74dc-a79f-efd1349ad622",
        "storage_key": "property/6767906449167598/01a01017-f6b4-74dc-a79f-efd1349ad622.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/state28tx/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11010902657907334938&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "state-28-kitchen--cocktails",
      "poi_latitude": "33.0465724",
      "poi_longitude": "-96.9957776",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 469-702-8222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-40a0-7768-a5a9-fc95bb550e89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-40a0-7768-a5a9-fc95bb550e89",
        "storage_key": "property/6767906449167598/019fc979-40a0-7768-a5a9-fc95bb550e89.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJh8wTHjEvTIYRGp_4DKGVzpg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_6ed7fd74-47d5-401d-800e-e8873b5a8305",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Harvest Chinese Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1288 W Main St #231, Lewisville, TX 75067, USA",
      "poi_short_description": "Basic Chinese fare from chop suey to lo mein features at this venue with lunch & dinner deals.",
      "poi_long_description": "Basic Chinese fare from chop suey to lo mein features at this venue with lunch & dinner deals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01017-f89a-711f-8514-4ade42081071.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-f89a-711f-8514-4ade42081071",
        "storage_key": "property/6767906449167598/01a01017-f89a-711f-8514-4ade42081071.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.harvestchinesetx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12457625017469189245&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harvest-chinese-restaurant",
      "poi_latitude": "33.0413361",
      "poi_longitude": "-97.0243277",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-436-6653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-40a0-7768-a5a9-fc95bb550e89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-40a0-7768-a5a9-fc95bb550e89",
        "storage_key": "property/6767906449167598/019fc979-40a0-7768-a5a9-fc95bb550e89.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1QYPGustTIYRfTxFN_Nf4qw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_281af0cd-1394-4d38-87d9-19c47e2b1347",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Main Street Cafe",
      "poi_type": "Restaurants",
      "poi_address": "208 E Main St, Lewisville, TX 75057, USA",
      "poi_short_description": "Easygoing diner serving American breakfast & lunch eats such as omelettes, pancakes & sandwiches.",
      "poi_long_description": "Easygoing diner serving American breakfast & lunch eats such as omelettes, pancakes & sandwiches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01017-fa2a-7189-838e-a082b0067d98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-fa2a-7189-838e-a082b0067d98",
        "storage_key": "property/6767906449167598/01a01017-fa2a-7189-838e-a082b0067d98.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mainstreetcafe.ai/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9879490166462335097&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "main-street-cafe",
      "poi_latitude": "33.0460107",
      "poi_longitude": "-96.9924878",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-436-6850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-40a0-7768-a5a9-fc95bb550e89.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-40a0-7768-a5a9-fc95bb550e89",
        "storage_key": "property/6767906449167598/019fc979-40a0-7768-a5a9-fc95bb550e89.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUceXXREuTIYRecjzbfb_Gok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_7b6e67aa-a48c-4c78-a458-b3e8e1c5b174",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Tom Thumb",
      "poi_type": "Shopping & Retail",
      "poi_address": "1075 FM3040, Lewisville, TX 75067, USA",
      "poi_short_description": "Clean neighborhood supermarket chain known for its bakery, deli and in-store pharmacy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-203c-76ba-820e-2323de49d49b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-203c-76ba-820e-2323de49d49b",
        "storage_key": "property/6767906449167598/019fc97c-203c-76ba-820e-2323de49d49b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://local.tomthumb.com/tx/lewisville/1075-w-fm3040.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=14065001044410346746&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tom-thumb",
      "poi_latitude": "33.0067429",
      "poi_longitude": "-97.0169006",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 214-488-3060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-4094-716d-9402-8d94aec1ff28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-4094-716d-9402-8d94aec1ff28",
        "storage_key": "property/6767906449167598/019fc979-4094-716d-9402-8d94aec1ff28.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF8Dh-S8sTIYR-qyTKe7rMMM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_0bd53fc7-f4a8-466b-b4e7-6f561dc714a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "1103 FM3040, Lewisville, TX 75067, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-3113-75a6-b9f5-87526b561956.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-3113-75a6-b9f5-87526b561956",
        "storage_key": "property/6767906449167598/019fc97c-3113-75a6-b9f5-87526b561956.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1103+w+round+grove+rd-lewisville-tx-75067/id=5960",
      "poi_directions_map_url": "https://maps.google.com/?cid=13285167060475715721&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "33.0066963",
      "poi_longitude": "-97.0198397",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 214-488-8680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-409c-716e-9921-04a685c09469",
        "storage_key": "property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1UyEbTAsTIYRiSBgvQ1lXrg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_7e3ac2c9-6abf-4697-a8dd-8cad5633329f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "460 E Round Grove Rd, Lewisville, TX 75067, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01018-0085-7131-bc2a-e9f523541d07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01018-0085-7131-bc2a-e9f523541d07",
        "storage_key": "property/6767906449167598/01a01018-0085-7131-bc2a-e9f523541d07.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.7-eleven.com/locations/tx/lewisville/460-e-round-grove-rd-35383?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1916869278603764639&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "33.0041297",
      "poi_longitude": "-96.9787796",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-459-2899",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019ff6b9-18d9-7648-8f2a-e20ceeb1b2f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6b9-18d9-7648-8f2a-e20ceeb1b2f7",
        "storage_key": "property/6767906449167598/019ff6b9-18d9-7648-8f2a-e20ceeb1b2f7.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ0arsi-4uTIYRn2MJ8HMWmho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_928cf46d-188f-4dc3-90fa-cffe8ab7606c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Kroger Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "4620 State Hwy 121, Lewisville, TX 75056, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01017-fc84-74c0-8403-5fdcc16540f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01017-fc84-74c0-8403-5fdcc16540f5",
        "storage_key": "property/6767906449167598/01a01017-fc84-74c0-8403-5fdcc16540f5.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tx/lewisville/castle-hills/035/00599?cid=loc_03500599_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=4550331237395997833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger-marketplace",
      "poi_latitude": "33.0621895",
      "poi_longitude": "-96.8890554",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 50 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 469-535-2479",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-4094-716d-9402-8d94aec1ff28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-4094-716d-9402-8d94aec1ff28",
        "storage_key": "property/6767906449167598/019fc979-4094-716d-9402-8d94aec1ff28.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe559HS4lTIYRiSRa1yYGJj8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_aceb9ad8-21e3-4581-9702-b674e6810bac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "4760 State Hwy 121, Lewisville, TX 75056, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01018-002e-76aa-a177-b2caeebd4168.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01018-002e-76aa-a177-b2caeebd4168",
        "storage_key": "property/6767906449167598/01a01018-002e-76aa-a177-b2caeebd4168.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/lewisville-state-highway-121/2520",
      "poi_directions_map_url": "https://maps.google.com/?cid=8862993478000929439&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "33.0638547",
      "poi_longitude": "-96.8845295",
      "poi_miles_from_property": "10.5",
      "poi_walking_minutes": "3 hours 55 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 469-287-0346",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-40b9-7005-b89c-ac6cebf333e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-40b9-7005-b89c-ac6cebf333e8",
        "storage_key": "property/6767906449167598/019fc979-40b9-7005-b89c-ac6cebf333e8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJITuhgi0lTIYRn2rZLpyt_3o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_a3339aa4-b504-4199-9d61-4fbdfb59b9b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "851 State Hwy 121, Lewisville, TX 75067, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019ff6b8-5788-712d-ac78-fc858aa2999f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b8-5788-712d-ac78-fc858aa2999f",
        "storage_key": "property/6767906449167598/019ff6b8-5788-712d-ac78-fc858aa2999f.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/lewisville-TX-683.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=12642300854746916159&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "32.9983816",
      "poi_longitude": "-96.963649",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 469-948-1026",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-40b9-7005-b89c-ac6cebf333e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-40b9-7005-b89c-ac6cebf333e8",
        "storage_key": "property/6767906449167598/019fc979-40b9-7005-b89c-ac6cebf333e8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJex4mox8vTIYRP6XORqV5cq8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_4096e00f-c172-4323-929e-e638d61ea92a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "The Vista Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "2401 S Stemmons Fwy, Lewisville, TX 75067, USA",
      "poi_short_description": "Clothing chain with trendy apparel, shoes & accessories for teen girls & young women.",
      "poi_long_description": "Clothing chain with trendy apparel, shoes & accessories for teen girls & young women.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-3b8f-7640-a5b5-30b724107e67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-3b8f-7640-a5b5-30b724107e67",
        "storage_key": "property/6767906449167598/019fc97c-3b8f-7640-a5b5-30b724107e67.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://thevistacenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8660594557472857579&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-vista-shopping-center",
      "poi_latitude": "33.0022926",
      "poi_longitude": "-96.9717506",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-315-0015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-40b9-7005-b89c-ac6cebf333e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-40b9-7005-b89c-ac6cebf333e8",
        "storage_key": "property/6767906449167598/019fc979-40b9-7005-b89c-ac6cebf333e8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ40kJKuQuTIYR693ZPd2cMHg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_3ea12721-2cfb-400c-b32d-b6bcc01891bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "901 N Stemmons Fwy, Lewisville, TX 75067, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-0429-7298-a54d-aa1533ec7b21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc979-0429-7298-a54d-aa1533ec7b21",
        "storage_key": "property/6767906449167598/019fc979-0429-7298-a54d-aa1533ec7b21.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Lewisville/TX/Lewisville/75067/524?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=13105884251758395062&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "33.0538363",
      "poi_longitude": "-97.01276690000002",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-436-1398",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-40b9-7005-b89c-ac6cebf333e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-40b9-7005-b89c-ac6cebf333e8",
        "storage_key": "property/6767906449167598/019fc979-40b9-7005-b89c-ac6cebf333e8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJDy0ptWAuTIYRtv5x_Ul04bU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_791f5262-8df4-4071-ad37-a4c804adbfb6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1099 W Main St, Lewisville, TX 75067, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019ff6b8-67e3-737e-a8bd-742656ade5fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b8-67e3-737e-a8bd-742656ade5fb",
        "storage_key": "property/6767906449167598/019ff6b8-67e3-737e-a8bd-742656ade5fb.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/lewisville-tx-pharmacies/1099-w-main-st-lewisville-tx-75067/storeid=6865?WT.mc_id=LS_GOOGLE_RX_6865",
      "poi_directions_map_url": "https://maps.google.com/?cid=4754155902935122162&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "33.0425905",
      "poi_longitude": "-97.0202272",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-436-3553",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-7908-74e9-a88d-754afd1acc3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-7908-74e9-a88d-754afd1acc3b",
        "storage_key": "property/6767906449167598/019fc97c-7908-74e9-a88d-754afd1acc3b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5RCo4-gtTIYR8kBG6Zon-kE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_c7b0cf5a-cb5e-42a6-b38a-0638eb28826d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Vista Ridge Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "E Round Grove Rd, Lewisville, TX 75067, USA",
      "poi_short_description": "Shopping center including clothing shops, bookstores and shoe stores, plus a food court and a movie theater.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019ff6b8-5778-774d-bc70-ec78cfbbbbaa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b8-5778-774d-bc70-ec78cfbbbbaa",
        "storage_key": "property/6767906449167598/019ff6b8-5778-774d-bc70-ec78cfbbbbaa.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://google.com/url?q=https://business.google.com/website_shared/launch_bw.html?f=https://amzn.to/3XYo3nt",
      "poi_directions_map_url": "https://maps.google.com/?cid=14234913634363632209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vista-ridge-plaza",
      "poi_latitude": "33.0033364",
      "poi_longitude": "-96.9798773",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-40b9-7005-b89c-ac6cebf333e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-40b9-7005-b89c-ac6cebf333e8",
        "storage_key": "property/6767906449167598/019fc979-40b9-7005-b89c-ac6cebf333e8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVUvHve4uTIYRUeqb2IeSjMU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_88daa543-1577-4ea4-b7a2-ec9691f7ff67",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Parkway Elementary",
      "poi_type": "Education",
      "poi_address": "2100 S Valley Pkwy, Lewisville, TX 75067, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://parkway.lisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17176111981037437045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parkway-elementary",
      "poi_latitude": "33.008823",
      "poi_longitude": "-97.0204817",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 469-713-5979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-4092-70e6-9ea2-20139c3045f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-4092-70e6-9ea2-20139c3045f5",
        "storage_key": "property/6767906449167598/019fc979-4092-70e6-9ea2-20139c3045f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJK3A_EDEsTIYRdUARBNjOXe4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_7efb7066-069b-4ec5-b1fc-ecb266adb753",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Lillie J. Jackson Early Childhood Center",
      "poi_type": "Education",
      "poi_address": "1651 S Valley Pkwy, Lewisville, TX 75067, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.lisd.net/Domain/33",
      "poi_directions_map_url": "https://maps.google.com/?cid=15770334045110795699&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lillie-j-jackson-early-childhood-center",
      "poi_latitude": "33.0266121",
      "poi_longitude": "-97.0178153",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 469-713-5986",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-4092-70e6-9ea2-20139c3045f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-4092-70e6-9ea2-20139c3045f5",
        "storage_key": "property/6767906449167598/019fc979-4092-70e6-9ea2-20139c3045f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0WSAFdAtTIYRs_0TXEJ729o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_eb65c8c6-f808-4c34-b2b0-9125c763ee28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Hedrick Middle School",
      "poi_type": "Education",
      "poi_address": "1526 Bellaire Blvd, Lewisville, TX 75067, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://hedrick.lisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10572373896620701755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hedrick-middle-school",
      "poi_latitude": "33.0269689",
      "poi_longitude": "-97.0257692",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 469-713-5188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-4092-70e6-9ea2-20139c3045f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-4092-70e6-9ea2-20139c3045f5",
        "storage_key": "property/6767906449167598/019fc979-4092-70e6-9ea2-20139c3045f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5Z_zirstTIYRO3iwTAueuJI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_120289b4-0e78-4b9e-9063-761ea3fa4410",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Durham Middle School",
      "poi_type": "Education",
      "poi_address": "2075 Edmonds Ln, Lewisville, TX 75067, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01018-00d5-74e8-8943-227ae9b68dad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01018-00d5-74e8-8943-227ae9b68dad",
        "storage_key": "property/6767906449167598/01a01018-00d5-74e8-8943-227ae9b68dad.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://durham.lisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7163770339217704049&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "durham-middle-school",
      "poi_latitude": "33.0119057",
      "poi_longitude": "-97.0035722",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 469-713-5963",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-4092-70e6-9ea2-20139c3045f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-4092-70e6-9ea2-20139c3045f5",
        "storage_key": "property/6767906449167598/019fc979-4092-70e6-9ea2-20139c3045f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJealJL4IuTIYRcQSNESvTamM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_048797e3-a706-4bf4-b439-30ecd405e50e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Huffines Middle School",
      "poi_type": "Education",
      "poi_address": "1440 N Valley Pkwy, Lewisville, TX 75077, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-4418-7675-8ba7-1582333cb446.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-4418-7675-8ba7-1582333cb446",
        "storage_key": "property/6767906449167598/019fc97c-4418-7675-8ba7-1582333cb446.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://huffines.lisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14381981060996685614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "huffines-middle-school",
      "poi_latitude": "33.0558785",
      "poi_longitude": "-97.03244010000002",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 469-713-5990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-4092-70e6-9ea2-20139c3045f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-4092-70e6-9ea2-20139c3045f5",
        "storage_key": "property/6767906449167598/019fc979-4092-70e6-9ea2-20139c3045f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpcP-jIstTIYRLl8ac5MPl8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_1eaf3484-afdb-4f38-ae2c-a451c6bc605e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Lewisville High School",
      "poi_type": "Education",
      "poi_address": "1098 W Main St, Lewisville, TX 75067, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-4479-746e-827c-e5d14cf702f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-4479-746e-827c-e5d14cf702f5",
        "storage_key": "property/6767906449167598/019fc97c-4479-746e-827c-e5d14cf702f5.webp",
        "width": 1280,
        "height": 884
      },
      "poi_business_url": "https://www.lisd.net/lhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=13217418244982932091&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lewisville-high-school",
      "poi_latitude": "33.0402359",
      "poi_longitude": "-97.0192205",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 469-713-5190",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-4092-70e6-9ea2-20139c3045f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-4092-70e6-9ea2-20139c3045f5",
        "storage_key": "property/6767906449167598/019fc979-4092-70e6-9ea2-20139c3045f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMzpudugtTIYRe4L5a92zbbc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_590add4d-2b2e-4e1e-92b9-9673d2bc86a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Mill Street Elementary School",
      "poi_type": "Education",
      "poi_address": "601 S Mill St, Lewisville, TX 75057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01018-039b-77d9-ac71-9815fc05ac62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01018-039b-77d9-ac71-9815fc05ac62",
        "storage_key": "property/6767906449167598/01a01018-039b-77d9-ac71-9815fc05ac62.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.lisd.net/millstreet",
      "poi_directions_map_url": "https://maps.google.com/?cid=16071486801879597452&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mill-street-elementary-school",
      "poi_latitude": "33.0411591",
      "poi_longitude": "-96.9941284",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 469-713-5965",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-4092-70e6-9ea2-20139c3045f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-4092-70e6-9ea2-20139c3045f5",
        "storage_key": "property/6767906449167598/019fc979-4092-70e6-9ea2-20139c3045f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2TA92FgvTIYRjIFpjhhkCd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_974e5096-b102-4ead-b314-d14bbc6e7575",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Student Success Center",
      "poi_type": "Education",
      "poi_address": "350 W College St, Lewisville, TX 75057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01018-0333-759b-abce-44098c20427e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01018-0333-759b-abce-44098c20427e",
        "storage_key": "property/6767906449167598/01a01018-0333-759b-abce-44098c20427e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lisd.net/SSC",
      "poi_directions_map_url": "https://maps.google.com/?cid=10194874833007908460&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "student-success-center",
      "poi_latitude": "33.0487068",
      "poi_longitude": "-97.0005623",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 469-713-5199",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-4092-70e6-9ea2-20139c3045f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-4092-70e6-9ea2-20139c3045f5",
        "storage_key": "property/6767906449167598/019fc979-4092-70e6-9ea2-20139c3045f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU1tXocovTIYRbJYBV6V4e40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_1bbc8eba-810c-4eac-a13a-5ca817160496",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Children's Lighthouse of Lewisville - Valley Parkway",
      "poi_type": "Education",
      "poi_address": "2200 S Valley Pkwy, Lewisville, TX 75067, USA",
      "poi_short_description": "Informal school and preschool for infants to age 12 featuring a splash pad, a playground, clean rooms and accommodating staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-4051-7655-b0f4-f57fd4f44a63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-4051-7655-b0f4-f57fd4f44a63",
        "storage_key": "property/6767906449167598/019fc97c-4051-7655-b0f4-f57fd4f44a63.webp",
        "width": 1280,
        "height": 666
      },
      "poi_business_url": "http://childrenslighthouse.com/valleyparkway",
      "poi_directions_map_url": "https://maps.google.com/?cid=4607157009616512812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-lighthouse-of-lewisville---valley-parkway",
      "poi_latitude": "33.0081406",
      "poi_longitude": "-97.0199345",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 469-956-6533",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-4092-70e6-9ea2-20139c3045f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-4092-70e6-9ea2-20139c3045f5",
        "storage_key": "property/6767906449167598/019fc979-4092-70e6-9ea2-20139c3045f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEQRUUjAsTIYRLKek9uPo7z8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_15b04896-7f17-4849-afb2-f2dc690dd49e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Primrose School of Old Orchard",
      "poi_type": "Education",
      "poi_address": "1253 W Round Grove Rd, Lewisville, TX 75067, USA",
      "poi_short_description": "Warm daycare that also offers preschool and after-school programs, with a focus on academics.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01018-02b9-76cb-bf2e-816f58942578.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01018-02b9-76cb-bf2e-816f58942578",
        "storage_key": "property/6767906449167598/01a01018-02b9-76cb-bf2e-816f58942578.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.primroseschools.com/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=4943036185996672288&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-old-orchard",
      "poi_latitude": "33.009775",
      "poi_longitude": "-97.025978",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 972-315-9495",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-4092-70e6-9ea2-20139c3045f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-4092-70e6-9ea2-20139c3045f5",
        "storage_key": "property/6767906449167598/019fc979-4092-70e6-9ea2-20139c3045f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD5NtZDYsTIYRIL07yjgxmUQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_cec9b012-9d17-4837-a209-a18447c17ff4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Lewisville Grand Theater",
      "poi_type": "Entertainment",
      "poi_address": "100 N Charles St, Lewisville, TX 75057, USA",
      "poi_short_description": "Spacious, contemporary venue featuring theater performances, events & classes, plus an art gallery.",
      "poi_long_description": "Spacious, contemporary venue featuring theater performances, events & classes, plus an art gallery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-4d17-775d-920c-b709e8006d74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-4d17-775d-920c-b709e8006d74",
        "storage_key": "property/6767906449167598/019fc97c-4d17-775d-920c-b709e8006d74.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lewisvillegrand.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9286174857949251761&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lewisville-grand-theater",
      "poi_latitude": "33.0467948",
      "poi_longitude": "-96.9972686",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-219-8446",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-409c-716e-9921-04a685c09469",
        "storage_key": "property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWaEPBA4uTIYRsYg6QtUe34A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_f7481cde-2164-4bc5-b08e-8c53dd24e679",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Wayne Ferguson Plaza",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "150 W Church St, Lewisville, TX 75057, USA",
      "poi_short_description": "Relaxed gathering spot for festivals and concerts in the summer and free fitness classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-4a6b-7127-912c-e881fe7fb5f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-4a6b-7127-912c-e881fe7fb5f5",
        "storage_key": "property/6767906449167598/019fc97c-4a6b-7127-912c-e881fe7fb5f5.webp",
        "width": 900,
        "height": 600
      },
      "poi_business_url": "https://www.playlewisville.com/parks/park-listings/wayne-ferguson-plaza",
      "poi_directions_map_url": "https://maps.google.com/?cid=15692859072330310905&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wayne-ferguson-plaza",
      "poi_latitude": "33.0471824",
      "poi_longitude": "-96.9956036",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-219-3401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-431a-723f-a2ff-0d77d0f733fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-431a-723f-a2ff-0d77d0f733fd",
        "storage_key": "property/6767906449167598/019fc979-431a-723f-a2ff-0d77d0f733fd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz-gW5BEuTIYR-aSDlC48yNk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_4f887b53-1a7c-4817-a998-dcc91460d763",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Cinemark Lewisville and XD",
      "poi_type": "Entertainment",
      "poi_address": "2401 S Stemmons Fwy, Lewisville, TX 75067, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-473b-7759-bad2-d297cb722b68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-473b-7759-bad2-d297cb722b68",
        "storage_key": "property/6767906449167598/019fc97c-473b-7759-bad2-d297cb722b68.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-lewisville/cinemark-lewisville-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&y_source=1_MTc0OTI5NTAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5421992385327197290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-lewisville-and-xd",
      "poi_latitude": "33.0015458",
      "poi_longitude": "-96.9707528",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-315-6152",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-790c-70ad-88e7-c5e0ce0b4d37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-790c-70ad-88e7-c5e0ce0b4d37",
        "storage_key": "property/6767906449167598/019fc97c-790c-70ad-88e7-c5e0ce0b4d37.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJqwew-uMuTIYRauxM9ljJPks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_d3f2a844-a984-420b-b8b1-43dcdb188916",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Studio Movie Grill",
      "poi_type": "Entertainment",
      "poi_address": "4800 State Hwy 121, The Colony, TX 75056, USA",
      "poi_short_description": "First-run, classic & kids' films, plus a varied American menu & cocktails brought to guests' seats.",
      "poi_long_description": "First-run, classic & kids' films, plus a varied American menu & cocktails brought to guests' seats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01018-0587-7239-9461-02e937841f3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01018-0587-7239-9461-02e937841f3c",
        "storage_key": "property/6767906449167598/01a01018-0587-7239-9461-02e937841f3c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.studiomoviegrill.com/the-colony?utm_source=google&utm_medium=organic&utm_campaign=gmb&utm_content=the%20colony",
      "poi_directions_map_url": "https://maps.google.com/?cid=8042399736907830264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "studio-movie-grill",
      "poi_latitude": "33.0669733",
      "poi_longitude": "-96.8836353",
      "poi_miles_from_property": "10.6",
      "poi_walking_minutes": "3 hours 57 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 469-405-8530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-790c-70ad-88e7-c5e0ce0b4d37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-790c-70ad-88e7-c5e0ce0b4d37",
        "storage_key": "property/6767906449167598/019fc97c-790c-70ad-88e7-c5e0ce0b4d37.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJtbHEnCwlTIYR-BMWRPNXnG8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_fbba7c9e-7882-4f84-ae2e-a7374445f3cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Push Start Play",
      "poi_type": "Entertainment",
      "poi_address": "1165 S Stemmons Fwy #192, Lewisville, TX 75067, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01018-06a3-717f-932e-62d4f3595a67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01018-06a3-717f-932e-62d4f3595a67",
        "storage_key": "property/6767906449167598/01a01018-06a3-717f-932e-62d4f3595a67.webp",
        "width": 1110,
        "height": 624
      },
      "poi_business_url": "https://pushstartplay.com/?utm_source=google&utm_medium=gbp&utm_campaign=gbp_optimization",
      "poi_directions_map_url": "https://maps.google.com/?cid=10266228139218844276&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "push-start-play",
      "poi_latitude": "33.0286128",
      "poi_longitude": "-96.9941616",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 214-222-5529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-409c-716e-9921-04a685c09469",
        "storage_key": "property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjx3W8CEvTIYRdDpCjRn4eI4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "video_arcade"
    },
    {
      "id": "custom_542ebe5c-fb64-4d3b-aae9-285d558b51bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Launch Family Entertainment - Lewisville",
      "poi_type": "Entertainment",
      "poi_address": "2460 S Stemmons Fwy, Lewisville, TX 75067, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-49b8-73e9-a41b-966680ef167e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-49b8-73e9-a41b-966680ef167e",
        "storage_key": "property/6767906449167598/019fc97c-49b8-73e9-a41b-966680ef167e.webp",
        "width": 1000,
        "height": 668
      },
      "poi_business_url": "https://launchfamilyentertainment.com/lewisville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13663028734562746255&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "launch-family-entertainment---lewisville",
      "poi_latitude": "33.0046327",
      "poi_longitude": "-96.9640579",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 214-222-5044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-409c-716e-9921-04a685c09469",
        "storage_key": "property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjVfe5EsvTIYRjz-Rhz7UnL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_55b52402-c1ed-4d32-bb90-62fb34586c3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Ninja Kidz Action Park",
      "poi_type": "Entertainment",
      "poi_address": "1087 W Main St Ste 102, Lewisville, TX 75067, USA",
      "poi_short_description": "Spacious, kid-oriented entertainment spot featuring a wide variety of trampolines, dodgeball and jousting activities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01018-065a-7020-a517-cc412941374c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01018-065a-7020-a517-cc412941374c",
        "storage_key": "property/6767906449167598/01a01018-065a-7020-a517-cc412941374c.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "http://www.ninjakidzparks.com/location-home/ninjakidz-102-lewisville",
      "poi_directions_map_url": "https://maps.google.com/?cid=3499118772246499054&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ninja-kidz-action-park",
      "poi_latitude": "33.0440368",
      "poi_longitude": "-97.0188751",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 469-312-2080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-409c-716e-9921-04a685c09469",
        "storage_key": "property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDeAwGKwtTIYR7k6n9vtdjzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_469ad808-f810-4bd2-9b63-bd64e7fe5cf3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "600 Sandy Beach Rd, Lewisville, TX 75057, USA",
      "poi_short_description": "Recreational park offering lake swimming & boating, a golf course, athletic fields & picnic areas.",
      "poi_long_description": "Recreational park offering lake swimming & boating, a golf course, athletic fields & picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-61e3-738f-93ee-845c66d3b0b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-61e3-738f-93ee-845c66d3b0b2",
        "storage_key": "property/6767906449167598/019fc97c-61e3-738f-93ee-845c66d3b0b2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.playlewisville.com/parks/park-listings/lake-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=3830431707728878479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-park",
      "poi_latitude": "33.0770484",
      "poi_longitude": "-97.0066054",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 972-219-3550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-431a-723f-a2ff-0d77d0f733fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-431a-723f-a2ff-0d77d0f733fd",
        "storage_key": "property/6767906449167598/019fc979-431a-723f-a2ff-0d77d0f733fd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNevF6_cxTIYRj5uS-1dtKDU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_6d6216a4-53ef-429b-9f90-36be9f0dbd30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "LEGOLAND® Discovery Center Dallas/Fort Worth",
      "poi_type": "Entertainment",
      "poi_address": "3000 Grapevine Mills Pkwy, Grapevine, TX 76051, USA",
      "poi_short_description": "Family entertainment center featuring Lego toy displays, rides & 4D films, plus gift shop.",
      "poi_long_description": "Family entertainment center featuring Lego toy displays, rides & 4D films, plus gift shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01018-067f-76da-8025-fcdae33d3fcd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01018-067f-76da-8025-fcdae33d3fcd",
        "storage_key": "property/6767906449167598/01a01018-067f-76da-8025-fcdae33d3fcd.webp",
        "width": 701,
        "height": 467
      },
      "poi_business_url": "https://www.legolanddiscoverycenter.com/dallas-fw/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=8213318445731368129&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legoland-discovery-center-dallasfort-worth",
      "poi_latitude": "32.9666453",
      "poi_longitude": "-97.0434661",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 469-444-3050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-409c-716e-9921-04a685c09469",
        "storage_key": "property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwU71w4YrTIYRwUz7QJyR-3E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_74e59542-efed-4b15-9ca4-3ed8a69261e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "SEA LIFE Grapevine Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "Grapevine Mills, 3000 Grapevine Mills Pkwy, Grapevine, TX 76051, USA",
      "poi_short_description": "Family-friendly exhibits with a variety of sea creatures (most offer play areas & group packages).",
      "poi_long_description": "Family-friendly exhibits with a variety of sea creatures (most offer play areas & group packages).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-1237-741e-a137-4b2888d70a0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc979-1237-741e-a137-4b2888d70a0a",
        "storage_key": "property/6767906449167598/019fc979-1237-741e-a137-4b2888d70a0a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.visitsealife.com/grapevine/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=432349789120866841&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sea-life-grapevine-aquarium",
      "poi_latitude": "32.9662578",
      "poi_longitude": "-97.0438015",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 469-444-3050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-409f-71d5-9142-0fe9100d5031.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-409f-71d5-9142-0fe9100d5031",
        "storage_key": "property/6767906449167598/019fc979-409f-71d5-9142-0fe9100d5031.webp",
        "width": 192,
        "height": 176
      },
      "poi_google_place_id": "ChIJV-3It4YrTIYRGapDr9cDAAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_6b09ea25-b219-432d-8f58-83c9c3d6c685",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Medical City Lewisville",
      "poi_type": "Health and Wellness",
      "poi_address": "500 W Main St, Lewisville, TX 75057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-1e02-73f8-bfc8-820ad80f0b92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc979-1e02-73f8-bfc8-820ad80f0b92",
        "storage_key": "property/6767906449167598/019fc979-1e02-73f8-bfc8-820ad80f0b92.webp",
        "width": 493,
        "height": 277
      },
      "poi_business_url": "https://www.medicalcityhealthcare.com/locations/medical-city-lewisville-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=2514616797377254311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medical-city-lewisville",
      "poi_latitude": "33.0454235",
      "poi_longitude": "-97.0049828",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 469-370-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-4096-7478-bbcb-4dc05e85f4e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-4096-7478-bbcb-4dc05e85f4e2",
        "storage_key": "property/6767906449167598/019fc979-4096-7478-bbcb-4dc05e85f4e2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJC-CoNgouTIYRp9Pmeae25SI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_05d24167-96b0-4ae3-aaaf-2fa4933a6feb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Baylor Scott & White Urgent Care+ Lewisville",
      "poi_type": "Health and Wellness",
      "poi_address": "540 Surf St, Lewisville, TX 75067, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019ff6b8-66b7-776d-a967-64b8dcfb8445.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b8-66b7-776d-a967-64b8dcfb8445",
        "storage_key": "property/6767906449167598/019ff6b8-66b7-776d-a967-64b8dcfb8445.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.bswhealth.com/locations/urgent-care/uc-plus-lewisville?utm_source=google-mybusiness&utm_medium=organic&utm_campaign=UC+Lewisville&utm_content=main-website",
      "poi_directions_map_url": "https://maps.google.com/?cid=6204775221569807245&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baylor-scott--white-urgent-care-lewisville",
      "poi_latitude": "33.0438973",
      "poi_longitude": "-97.014445",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-420-9900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-409c-716e-9921-04a685c09469",
        "storage_key": "property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbfW9juYtTIYRjWPQkDDKG1Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_fc0da6f8-2b8b-4d3e-9335-ec1cd8b9d118",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Concentra Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "2403 S Stemmons Fwy Ste. 103, Lewisville, TX 75067, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01018-0851-751f-8da3-cb60a675fdda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01018-0851-751f-8da3-cb60a675fdda",
        "storage_key": "property/6767906449167598/01a01018-0851-751f-8da3-cb60a675fdda.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.concentra.com/?utm_source=Yext&utm_medium=Organic&utm_campaign=Homepage%20Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=10406026546361582435&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "concentra-urgent-care",
      "poi_latitude": "33.0056402",
      "poi_longitude": "-96.9725531",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-829-2999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-409c-716e-9921-04a685c09469",
        "storage_key": "property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo_v4BeUuTIYRY8MqqwKiaZA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_6d6e0c6c-c8d1-4ada-9d78-5784ee98fae7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "힐링핸즈 병원 (Healing Hands Clinic)",
      "poi_type": "Health and Wellness",
      "poi_address": "2405 S Stemmons Fwy Ste 230, Lewisville, TX 75067, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01018-0ad2-750e-973b-aa351052022d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01018-0ad2-750e-973b-aa351052022d",
        "storage_key": "property/6767906449167598/01a01018-0ad2-750e-973b-aa351052022d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://hhwctx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11357029159155469449&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "--healing-hands-clinic",
      "poi_latitude": "33.0030361",
      "poi_longitude": "-96.9708813",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 469-293-4606",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-409c-716e-9921-04a685c09469",
        "storage_key": "property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtz9Q-dovTIYRiQw3H9lFnJ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_110a48dc-7429-4f85-84d5-a6655661baaa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "801 W Main St, Lewisville, TX 75067, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-541f-7008-8d31-ef378061315e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-541f-7008-8d31-ef378061315e",
        "storage_key": "property/6767906449167598/019fc97c-541f-7008-8d31-ef378061315e.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/217-lewisville-tx/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=14101684157502184564&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "33.0471863",
      "poi_longitude": "-97.0140609",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-221-1150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-7908-74e9-a88d-754afd1acc3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-7908-74e9-a88d-754afd1acc3b",
        "storage_key": "property/6767906449167598/019fc97c-7908-74e9-a88d-754afd1acc3b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS_iUT-QtTIYRdNyr_gY_s8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_efada612-887d-43c4-bf71-d3aaec1c8dff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "798 E Vista Ridge Mall Dr, Lewisville, TX 75067, USA",
      "poi_short_description": "Chain health club offering cardio and strength equipment, plus group classes, and pools.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-1b8f-760a-93e1-863e7fd82a01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc979-1b8f-760a-93e1-863e7fd82a01",
        "storage_key": "property/6767906449167598/019fc979-1b8f-760a-93e1-863e7fd82a01.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=334&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=12745807886122409510&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "33.0005792",
      "poi_longitude": "-96.9650374",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-315-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-409c-716e-9921-04a685c09469",
        "storage_key": "property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt5FFyOEuTIYRJt6yA7404rA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_388488dc-2076-4991-8f2b-ce9680b8d5d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "500 E Round Grove Rd #201, Lewisville, TX 75067, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-1c02-73b1-8af3-fef90285a6d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc979-1c02-73b1-8af3-fef90285a6d7",
        "storage_key": "property/6767906449167598/019fc979-1c02-73b1-8af3-fef90285a6d7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/lewisville-round-grove-rd-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=15866743250462238426&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.0030498",
      "poi_longitude": "-96.9765312",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 469-293-2215",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-409c-716e-9921-04a685c09469",
        "storage_key": "property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpYXxAXAuTIYR2uYgsuv-Mdw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4649454a-a12b-497a-b645-535f77166a0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Blue Anjou Yoga Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "427 W Main St, Lewisville, TX 75057, USA",
      "poi_short_description": "Cozy yoga studio offering a variety of classes and teacher training programs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-594a-76ec-a013-1b4ea0898330.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-594a-76ec-a013-1b4ea0898330",
        "storage_key": "property/6767906449167598/019fc97c-594a-76ec-a013-1b4ea0898330.webp",
        "width": 864,
        "height": 473
      },
      "poi_business_url": "http://www.blueanjou.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13912147855743026414&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-anjou-yoga-studio",
      "poi_latitude": "33.0465534",
      "poi_longitude": "-97.0022612",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 469-645-8555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-4092-70e6-9ea2-20139c3045f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-4092-70e6-9ea2-20139c3045f5",
        "storage_key": "property/6767906449167598/019fc979-4092-70e6-9ea2-20139c3045f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEXbfRQkuTIYR7oRG3MPgEcE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_66660af2-215b-4eb5-a495-c8ea02ece589",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1950 S Valley Pkwy, Lewisville, TX 75067, USA",
      "poi_short_description": "City park popular with families boasting 3 playgrounds, trails & an indoor recreation center.",
      "poi_long_description": "City park popular with families boasting 3 playgrounds, trails & an indoor recreation center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-5b37-724d-9a9a-2f545a511609.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-5b37-724d-9a9a-2f545a511609",
        "storage_key": "property/6767906449167598/019fc97c-5b37-724d-9a9a-2f545a511609.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.playlewisville.com/parks/park-listings/memorial-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4616919215009787604&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-park",
      "poi_latitude": "33.0192055",
      "poi_longitude": "-97.0217463",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 972-219-3550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-431a-723f-a2ff-0d77d0f733fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-431a-723f-a2ff-0d77d0f733fd",
        "storage_key": "property/6767906449167598/019fc979-431a-723f-a2ff-0d77d0f733fd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJB97j-cwtTIYR1G5Vh5CXEkA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bca25eb7-2277-402a-b78b-068469ff2b43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Sun Valley Aquatic Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "801 S Valley Pkwy, Lewisville, TX 75067, USA",
      "poi_short_description": "Summertime water park with pools, slides, a lazy river & play features plus a concessions area.",
      "poi_long_description": "Summertime water park with pools, slides, a lazy river & play features plus a concessions area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-5d1d-7199-b7b8-8dcbce4a4871.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-5d1d-7199-b7b8-8dcbce4a4871",
        "storage_key": "property/6767906449167598/019fc97c-5d1d-7199-b7b8-8dcbce4a4871.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.playlewisville.com/facilities/aquatics/sun-valley-aquatic-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=11684858617242855619&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sun-valley-aquatic-center",
      "poi_latitude": "33.0382421",
      "poi_longitude": "-97.0197767",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-219-3743",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-409c-716e-9921-04a685c09469",
        "storage_key": "property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ-5CiMItTIYRwyhs2wD1KKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "custom_9074dab3-8bde-49ed-8a48-6cace755aded",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Old Town Splash Park",
      "poi_type": "Entertainment",
      "poi_address": "535 W College St, Lewisville, TX 75057, USA",
      "poi_short_description": "Laid-back public park featuring a seasonal outdoor pool, plus splash pads and a playground.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-192c-701a-ade5-3dc7e8f78362.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc979-192c-701a-ade5-3dc7e8f78362",
        "storage_key": "property/6767906449167598/019fc979-192c-701a-ade5-3dc7e8f78362.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.playlewisville.com/facilities/aquatics/old-town-splash-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2079476320965366615&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-town-splash-park",
      "poi_latitude": "33.0501274",
      "poi_longitude": "-97.0050514",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-219-3744",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-409c-716e-9921-04a685c09469",
        "storage_key": "property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv5b2bgguTIYRVxP6RbLI2xw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_5a7841c2-8a64-459b-a7e9-68b633789d05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Lewisville Railroad Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1301 Bennett Ln, Lewisville, TX 75057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-5b41-7319-aade-fd4b8f0c9832.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-5b41-7319-aade-fd4b8f0c9832",
        "storage_key": "property/6767906449167598/019fc97c-5b41-7319-aade-fd4b8f0c9832.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.playlewisville.com/parks/park-listings/railroad-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9888952657572346167&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lewisville-railroad-park",
      "poi_latitude": "33.0280711",
      "poi_longitude": "-96.9717402",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 972-219-5077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-431a-723f-a2ff-0d77d0f733fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-431a-723f-a2ff-0d77d0f733fd",
        "storage_key": "property/6767906449167598/019fc979-431a-723f-a2ff-0d77d0f733fd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ0OL9lAuTIYRNzlBUwyePIk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c4223ccf-b210-46cf-883c-f503d9cd0459",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "LLELA Nature Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "201 E Jones St, Lewisville, TX 75057, USA",
      "poi_short_description": "Scenic nature preserve offering a visitor center, walking trails, fishing, camping, kayaking & more.",
      "poi_long_description": "Scenic nature preserve offering a visitor center, walking trails, fishing, camping, kayaking & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-5df2-71fc-92d9-a013cc8228c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-5df2-71fc-92d9-a013cc8228c1",
        "storage_key": "property/6767906449167598/019fc97c-5df2-71fc-92d9-a013cc8228c1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.llela.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11336426955797826332&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "llela-nature-preserve",
      "poi_latitude": "33.0638972",
      "poi_longitude": "-96.9922426",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 972-219-3550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-431a-723f-a2ff-0d77d0f733fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-431a-723f-a2ff-0d77d0f733fd",
        "storage_key": "property/6767906449167598/019fc979-431a-723f-a2ff-0d77d0f733fd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJc7_GUP8xTIYRHAt-2kAUU50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_7de2d757-33de-4cd1-a187-19c7797730f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Vista Ridge Athletic Complex",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2950 Lake Vista Dr, Lewisville, TX 75067, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-62a7-716f-8390-482c811e073a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-62a7-716f-8390-482c811e073a",
        "storage_key": "property/6767906449167598/019fc97c-62a7-716f-8390-482c811e073a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cityoflewisville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16410279894268298953&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vista-ridge-athletic-complex",
      "poi_latitude": "32.9889736",
      "poi_longitude": "-96.9610786",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-219-3550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-431a-723f-a2ff-0d77d0f733fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-431a-723f-a2ff-0d77d0f733fd",
        "storage_key": "property/6767906449167598/019fc979-431a-723f-a2ff-0d77d0f733fd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJgZUihNguTIYRycaYUp4GveM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_170be183-28a8-4eac-bf77-abe29b00bbe5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Meadowlake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1430 Brazos Blvd, Lewisville, TX 75077, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01018-0c6b-7488-ba6e-9c7879aa99d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01018-0c6b-7488-ba6e-9c7879aa99d8",
        "storage_key": "property/6767906449167598/01a01018-0c6b-7488-ba6e-9c7879aa99d8.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.playlewisville.com/parks/park-listings/meadowlake-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6156877141140294943&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meadowlake-park",
      "poi_latitude": "33.0770955",
      "poi_longitude": "-97.0351763",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 972-219-3550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-431a-723f-a2ff-0d77d0f733fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-431a-723f-a2ff-0d77d0f733fd",
        "storage_key": "property/6767906449167598/019fc979-431a-723f-a2ff-0d77d0f733fd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJleE0494zTIYRH81jqyOfcVU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_136f29db-cdb6-4c2b-bb15-380bf96e8ee8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Orchard Valley Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Orchard Valley Park, Lewisville, TX 75077, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01018-0ef6-73c3-8319-434469b24fda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01018-0ef6-73c3-8319-434469b24fda",
        "storage_key": "property/6767906449167598/01a01018-0ef6-73c3-8319-434469b24fda.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.playlewisville.com/parks/park-listings/orchard-valley-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4896497238651718889&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orchard-valley-park",
      "poi_latitude": "33.0600884",
      "poi_longitude": "-97.0242558",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-219-3550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-431a-723f-a2ff-0d77d0f733fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-431a-723f-a2ff-0d77d0f733fd",
        "storage_key": "property/6767906449167598/019fc979-431a-723f-a2ff-0d77d0f733fd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJTe8FoQotTIYR6UyEuUva80M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_54d73a22-1ee4-4385-9e01-23def254095e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Lenard L Woods Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1000 Arbour Way, Lewisville, TX 75077, USA",
      "poi_short_description": "Sprawling community park featuring over 28 acres of trails & fields, including a disc-golf course.",
      "poi_long_description": "Sprawling community park featuring over 28 acres of trails & fields, including a disc-golf course.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01018-0c45-769b-89db-13fbb585be4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01018-0c45-769b-89db-13fbb585be4b",
        "storage_key": "property/6767906449167598/01a01018-0c45-769b-89db-13fbb585be4b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.playlewisville.com/parks/park-listings/l-l-woods-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=3281258035989545661&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lenard-l-woods-park",
      "poi_latitude": "33.0543798",
      "poi_longitude": "-97.0380632",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 972-436-2077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-431a-723f-a2ff-0d77d0f733fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-431a-723f-a2ff-0d77d0f733fd",
        "storage_key": "property/6767906449167598/019fc979-431a-723f-a2ff-0d77d0f733fd.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMY9sEoYtTIYRvYKNg8xeiS0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_45fd071d-8bdc-4133-8abd-c018dd31701c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Hebron Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "952 Lakeside Cir, Lewisville, TX 75057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-33bf-709e-b3fc-9a304a78b066.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc979-33bf-709e-b3fc-9a304a78b066",
        "storage_key": "property/6767906449167598/019fc979-33bf-709e-b3fc-9a304a78b066.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dcta.net/images/uploads/content_files/connect_files/1-15-update/route21-1-15.pdf",
      "poi_directions_map_url": "https://maps.google.com/?cid=6216114618958893695&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hebron-station",
      "poi_latitude": "33.0101482",
      "poi_longitude": "-96.9584227",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-4326-7386-b2b6-e9fbcd07e65d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-4326-7386-b2b6-e9fbcd07e65d",
        "storage_key": "property/6767906449167598/019fc979-4326-7386-b2b6-e9fbcd07e65d.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJby-eZwMvTIYRf1Iowk8TRFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_a6fb0e67-406e-4dcd-a122-ad6d35982058",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Old Town",
      "poi_type": "Transportation & Transit",
      "poi_address": "617 E Main St, Lewisville, TX 75057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-3632-7609-b50e-a4af286ee052.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc979-3632-7609-b50e-a4af286ee052",
        "storage_key": "property/6767906449167598/019fc979-3632-7609-b50e-a4af286ee052.webp",
        "width": 1280,
        "height": 901
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7239306256237320260&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-town",
      "poi_latitude": "33.04736330000001",
      "poi_longitude": "-96.9863475",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-4326-7386-b2b6-e9fbcd07e65d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-4326-7386-b2b6-e9fbcd07e65d",
        "storage_key": "property/6767906449167598/019fc979-4326-7386-b2b6-e9fbcd07e65d.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJJwu6ERYuTIYRRNhJP68ud2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_92ec5634-ab00-489d-92fc-b65dde23b051",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Highland Village/Lewisville Lake Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "2998 N Stemmons Fwy, Lewisville, TX 75077, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-6748-72df-af87-1dd4ad195d9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-6748-72df-af87-1dd4ad195d9e",
        "storage_key": "property/6767906449167598/019fc97c-6748-72df-af87-1dd4ad195d9e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7343931499598697122&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "highland-villagelewisville-lake-station",
      "poi_latitude": "33.0834155",
      "poi_longitude": "-97.0259929",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-4326-7386-b2b6-e9fbcd07e65d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-4326-7386-b2b6-e9fbcd07e65d",
        "storage_key": "property/6767906449167598/019fc979-4326-7386-b2b6-e9fbcd07e65d.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJh5AgfhUyTIYRotJhAMri6mU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_3c9f610d-03b8-458b-ae54-6a20c00127c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Trinity Mills",
      "poi_type": "Transportation & Transit",
      "poi_address": "2525 Blanton Dr, Carrollton, TX 75006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-2f75-7338-b6aa-ecff1756326c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc979-2f75-7338-b6aa-ecff1756326c",
        "storage_key": "property/6767906449167598/019fc979-2f75-7338-b6aa-ecff1756326c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dart.org/riding/stations/trinitymillsstation.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=777499669808973001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trinity-mills",
      "poi_latitude": "32.98092",
      "poi_longitude": "-96.9264",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-4326-7386-b2b6-e9fbcd07e65d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-4326-7386-b2b6-e9fbcd07e65d",
        "storage_key": "property/6767906449167598/019fc979-4326-7386-b2b6-e9fbcd07e65d.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJdbbbi1MvTIYRyYTyj9Q7ygo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_a2d1d442-d6f1-4416-aabf-961f7bc33ca1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Downtown Denton Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "604 E Hickory St, Denton, TX 76205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-64f6-71cf-b2e9-8d26f0817bf7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-64f6-71cf-b2e9-8d26f0817bf7",
        "storage_key": "property/6767906449167598/019fc97c-64f6-71cf-b2e9-8d26f0817bf7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12243141428338983573&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-denton-transit-center",
      "poi_latitude": "33.213705",
      "poi_longitude": "-97.126051",
      "poi_miles_from_property": "17.6",
      "poi_walking_minutes": "6 hours 29 mins",
      "poi_biking_minutes": "1 hour 46 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-793a-7508-96c7-1d71b2406974.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-793a-7508-96c7-1d71b2406974",
        "storage_key": "property/6767906449167598/019fc97c-793a-7508-96c7-1d71b2406974.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0_P6Z43KTYYRlYIDG0Ng6Kk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_7dd1faba-a98d-4e1b-aab4-2cebe9518d98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "MedPark Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "3220 Medpark Dr, Denton, TX 76210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-65b9-703c-aed7-6fc2efd81e78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-65b9-703c-aed7-6fc2efd81e78",
        "storage_key": "property/6767906449167598/019fc97c-65b9-703c-aed7-6fc2efd81e78.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.dcta.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6211726032118505052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medpark-station",
      "poi_latitude": "33.1820209",
      "poi_longitude": "-97.0914304",
      "poi_miles_from_property": "15.2",
      "poi_walking_minutes": "5 hours 37 mins",
      "poi_biking_minutes": "1 hour 33 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 940-243-0077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-7913-72d6-b896-785f3d03e6fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-7913-72d6-b896-785f3d03e6fd",
        "storage_key": "property/6767906449167598/019fc97c-7913-72d6-b896-785f3d03e6fd.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJKx2N0dI0TIYRXF54Qup7NFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_bc48975d-790f-47bf-90a3-56d5febb3ce8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Dallas Fort Worth International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2400 Aviation Dr, DFW Airport, TX 75261, USA",
      "poi_short_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_long_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-6761-71ed-9e2a-7330766e825a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-6761-71ed-9e2a-7330766e825a",
        "storage_key": "property/6767906449167598/019fc97c-6761-71ed-9e2a-7330766e825a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dfwairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8300766736265584668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-fort-worth-international-airport",
      "poi_latitude": "32.8921983",
      "poi_longitude": "-97.0391232",
      "poi_miles_from_property": "11",
      "poi_walking_minutes": "4 hours 3 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 972-973-3112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-7904-77ae-a139-8438aa55c6ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-7904-77ae-a139-8438aa55c6ee",
        "storage_key": "property/6767906449167598/019fc97c-7904-77ae-a139-8438aa55c6ee.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpyoiDWYqTIYRHCB9Bl4_MnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_72ec084e-6df4-4de8-935b-348489165fac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Ericsson Lewisville Center of Excellence",
      "poi_type": "Education",
      "poi_address": "2555 S Valley Pkwy, Lewisville, TX 75067, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01018-102f-74ba-8105-3aeffdb8e3d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01018-102f-74ba-8105-3aeffdb8e3d1",
        "storage_key": "property/6767906449167598/01a01018-102f-74ba-8105-3aeffdb8e3d1.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.ericsson.com/en",
      "poi_directions_map_url": "https://maps.google.com/?cid=15346332451046040894&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ericsson-lewisville-center-of-excellence",
      "poi_latitude": "33.0011086",
      "poi_longitude": "-97.0145563",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-4092-70e6-9ea2-20139c3045f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-4092-70e6-9ea2-20139c3045f5",
        "storage_key": "property/6767906449167598/019fc979-4092-70e6-9ea2-20139c3045f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa-ob2Q0sTIYRPiWmTQ4g-dQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_fa50028a-6f1a-440b-9102-ca142ef1f18c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "DJO Lewisville",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2900 Lake Vista Dr, Lewisville, TX 75067, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://enovis.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7234812730685735372&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "djo-lewisville",
      "poi_latitude": "32.9908689",
      "poi_longitude": "-96.9619435",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-409c-716e-9921-04a685c09469",
        "storage_key": "property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT9hMVJQvTIYRzEH_zNg3Z2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_544b35ef-fa2e-40b2-b036-13ce2c94321e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Lewisville Independent School District",
      "poi_type": "Education",
      "poi_address": "1565 W Main St #220, Lewisville, TX 75067, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-69b2-700c-a9d7-abc2aaf0dca4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-69b2-700c-a9d7-abc2aaf0dca4",
        "storage_key": "property/6767906449167598/019fc97c-69b2-700c-a9d7-abc2aaf0dca4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.lisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14983067533701921762&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lewisville-independent-school-district",
      "poi_latitude": "33.0440774",
      "poi_longitude": "-97.035263",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 469-713-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-4092-70e6-9ea2-20139c3045f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-4092-70e6-9ea2-20139c3045f5",
        "storage_key": "property/6767906449167598/019fc979-4092-70e6-9ea2-20139c3045f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_7CoNZEtTIYR4rv9x4mM7s8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1105e1bc-f26b-4fd3-b3ea-0165c8de67bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Lewisville City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "151 W Church St, Lewisville, TX 75057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-6bb3-73ed-9372-5206db22f4f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-6bb3-73ed-9372-5206db22f4f3",
        "storage_key": "property/6767906449167598/019fc97c-6bb3-73ed-9372-5206db22f4f3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.cityoflewisville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11720423613431398683&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lewisville-city-hall",
      "poi_latitude": "33.0478003",
      "poi_longitude": "-96.9953369",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-219-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-7938-770c-a7b3-633524a4d22b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-7938-770c-a7b3-633524a4d22b",
        "storage_key": "property/6767906449167598/019fc97c-7938-770c-a7b3-633524a4d22b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa5vy7FYvTIYRG8Gtzy1Pp6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_cbdcd359-db03-43e9-ad5c-d31a5bbe24db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Denton County Justice of the Peace Precinct 3",
      "poi_type": "Major Employers & Offices",
      "poi_address": "400 N Valley Pkwy #2012, Lewisville, TX 75067, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01018-1545-70d9-be19-6e15f374f141.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01018-1545-70d9-be19-6e15f374f141",
        "storage_key": "property/6767906449167598/01a01018-1545-70d9-be19-6e15f374f141.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dentoncounty.gov/483/Justice-of-the-Peace-Precinct-3",
      "poi_directions_map_url": "https://maps.google.com/?cid=1885614198644801425&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "denton-county-justice-of-the-peace-precinct-3",
      "poi_latitude": "33.0459909",
      "poi_longitude": "-97.0215132",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-434-4750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-7938-770c-a7b3-633524a4d22b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc97c-7938-770c-a7b3-633524a4d22b",
        "storage_key": "property/6767906449167598/019fc97c-7938-770c-a7b3-633524a4d22b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj9VCy-4tTIYRkf-njR8MKxo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_15dbafdd-d9b1-4efe-a250-71d385d45bcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "University of North Texas",
      "poi_type": "Education",
      "poi_address": "1155 Union Cir, Denton, TX 76205, USA",
      "poi_short_description": "Expansive public research university founded in 1890 & known for its music school, among others.",
      "poi_long_description": "Expansive public research university founded in 1890 & known for its music school, among others.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc97c-71cf-763a-b120-911b049a62df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97c-71cf-763a-b120-911b049a62df",
        "storage_key": "property/6767906449167598/019fc97c-71cf-763a-b120-911b049a62df.webp",
        "width": 1280,
        "height": 1002
      },
      "poi_business_url": "https://www.unt.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=846007427916065034&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-north-texas",
      "poi_latitude": "33.2090389",
      "poi_longitude": "-97.153439",
      "poi_miles_from_property": "19",
      "poi_walking_minutes": "7 hours 2 mins",
      "poi_biking_minutes": "1 hour 57 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 940-565-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-4092-70e6-9ea2-20139c3045f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-4092-70e6-9ea2-20139c3045f5",
        "storage_key": "property/6767906449167598/019fc979-4092-70e6-9ea2-20139c3045f5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyY815HPKTYYRCmlH-kWfvQs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_edd26a82-0869-448e-a161-a2839ebcd6d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Texas Health Presbyterian Hospital Flower Mound",
      "poi_type": "Health and Wellness",
      "poi_address": "4400 Long Prairie Rd, Flower Mound, TX 75028, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-2737-723e-9848-40ec2fbf3e0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc979-2737-723e-9848-40ec2fbf3e0e",
        "storage_key": "property/6767906449167598/019fc979-2737-723e-9848-40ec2fbf3e0e.webp",
        "width": 1280,
        "height": 792
      },
      "poi_business_url": "https://www.texashealth.org/locations/texas-health-flower-mound",
      "poi_directions_map_url": "https://maps.google.com/?cid=10658615510840280430&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-health-presbyterian-hospital-flower-mound",
      "poi_latitude": "33.0456181",
      "poi_longitude": "-97.0676197",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 469-322-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-4096-7478-bbcb-4dc05e85f4e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-4096-7478-bbcb-4dc05e85f4e2",
        "storage_key": "property/6767906449167598/019fc979-4096-7478-bbcb-4dc05e85f4e2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJr6RXXWgtTIYRboUa2VUC65M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_bdb52fb5-986f-43bc-abbc-8811f053ecf0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Baylor Scott & White Primary Care - Castle Hills",
      "poi_type": "Health and Wellness",
      "poi_address": "1700 FM 544 Ste 200, Lewisville, TX 75056, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01018-12d7-7298-bbe0-d0c5eca0a558.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01018-12d7-7298-bbe0-d0c5eca0a558",
        "storage_key": "property/6767906449167598/01a01018-12d7-7298-bbe0-d0c5eca0a558.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.bswhealth.com/locations/clinic/primary-care-castle-hills?utm_content=main-website&utm_source=pg-google&utm_medium=organic&utm_campaign=29985-9717825",
      "poi_directions_map_url": "https://maps.google.com/?cid=7839675421177467350&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baylor-scott--white-primary-care---castle-hills",
      "poi_latitude": "33.045756",
      "poi_longitude": "-96.9198876",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 469-800-4250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-409c-716e-9921-04a685c09469",
        "storage_key": "property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5SOLBBAlTIYR1tGkWUIfzGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_43116d31-c464-4298-ac3d-f3148d7a3a05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "poi_name": "Kuehne + Nagel Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1800 Waters Ridge Dr, Lewisville, TX 75057, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01018-1690-71fc-a9ff-86053f3bb814.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01018-1690-71fc-a9ff-86053f3bb814",
        "storage_key": "property/6767906449167598/01a01018-1690-71fc-a9ff-86053f3bb814.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://us.kuehne-nagel.com/?utm_source=GMB&utm_medium=GMB-USA&utm_campaign=GMB-USA",
      "poi_directions_map_url": "https://maps.google.com/?cid=7447975390718918901&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kuehne--nagel-inc",
      "poi_latitude": "33.0176506",
      "poi_longitude": "-96.9717636",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-459-7655",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc979-409c-716e-9921-04a685c09469",
        "storage_key": "property/6767906449167598/019fc979-409c-716e-9921-04a685c09469.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrRbvD18vTIYR9QCnIyiGXGc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    }
  ],
  "office_hours": [
    {
      "id": "ec_d9a8770be69621e0361c7029",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_cb8a0a64bfad35e53e9c3ada",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_e5298ce182eef8e86a69b5f8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_a328e35a064adcd00d01576f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_ee73e392249d1677d804699b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_d78045445dee27ff86de71aa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_08c438f0d7c11b59a1eb96be",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "rating": "5",
      "name": "Adi Bluth",
      "text": "We’ve lived here for almost 2 years and have loved it! Even with the smallest floor plan it never feels cramped—the kitchen is huge with tons of counter space, the living room ceiling is vaulted on the third floor, and the bathroom and bedroom also feel spacious. Nothing is outdated. Everything was clean and smooth with moving in, and maintenance requests are taken care of quickly, but we haven’t needed them often. The complex is quiet and super well kept. The pool area is kept pristine and is maintained daily, it’s also open year round which is nice. There’s nice grassy areas and paths to go on walks around the complex. The gym is never very busy and isn’t huge but also isn’t lacking in any of the basics. The location is also wonderful, it’s not right on a busy street but does have easy access to the nearby highways.",
      "date": "2026-02-15",
      "title": "false"
    },
    {
      "id": "ec_b5d9620ee096e70d38d0dea6",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "rating": "5",
      "name": "Dr. Mark Evers",
      "text": "So sad to be leaving…but my family is moving to a house…baby is on the way!\n\nSo, get it while you can. #12109 available Aug 29, 2025.\nA coveted, hard to get, 1 bed 1 bath with attached garage. 900+ square feet. A silly amount of storage with a huge garage. A front door that walks out to a tranquil path straight from a Robert Frost poem. Towering Cypress and Oaks with Myrtles.\nThis property is well maintained and the staff are excellent. Anytime I had an issue, maintenance was there to fix it. When my AC went down due to the storms, maintenance was there at midnight working on it. Armando and the other guys are on top of it. The pool and rest of the property are clean and well maintained. I love that they have parties and food trucks.\n\nNow the bad…parking. The parking is a bit of an issue, which is why these garage units are an absolute. You get a garage with tons of storage space and a parking spot in front of your garage for your guest. Otherwise if you rent a non-garage, you get to struggle and there are limited guest spots. They do tow, so guest must register every day. By following the rules, none of my guests have ever been towed.\n\nOverall, I’d live here again and highly recommend it to anyone. Go see the crew today before my unit is gone. I promise you it will not last long.",
      "date": "2025-08-17",
      "title": "false"
    },
    {
      "id": "ec_b8cb9ef17648a0239fbd509d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "rating": "5",
      "name": "Raz Alvarado",
      "text": "My other half and I have lived here for a year and have decided to renew our contract. Both Chelsea and TJ in the office are very quick to respond to our request With a sense of urgency. We constantly remind both of how much we appreciate the treatment Especially coming from a property that was not managed well. We like it here you will too!",
      "date": "2026-08-04",
      "title": "false"
    },
    {
      "id": "ec_81af060123f26545dcfd1bd7",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "rating": "5",
      "name": "Nat Kar",
      "text": "I’ve probably been a pain to deal with a handful of times, but Chelsea and the office manager TJ at Cypress at Lewisville have been nothing but patient, kind, and incredibly helpful. One thing I really appreciate is that it’s always them — the same familiar faces who know me, know my situation, and don’t make me start from scratch every time I walk into the office. That consistency alone makes a huge difference compared to my last apartment, where the staff changed constantly.\n\nMy apartment itself has been great — I love the wood floors, minimal carpet, and how easy it is to keep everything clean. The community is quiet, well-kept, and feels safe.\n\nI’ve also seen people complain about the towing policy, but honestly, I get why it exists. At other complexes I’ve lived in, random cars would sit for months in the best parking spots, and residents were the ones who suffered. Here, parking is actually available because they enforce the rules. It’s one of those things you don’t appreciate until you’ve lived somewhere without it.\nOverall, I’m really grateful for the team here and the way they take care of their residents. Chelsea and TJ truly go above and beyond, and it shows. 🙏",
      "date": "2026-03-28",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_c58f2fb51943ec6c91381280",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "A3 - 1 bed, 1 bath, 869 sqft.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-a8eb-775c-b86d-2cdd7a637a34.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01024-a8eb-775c-b86d-2cdd7a637a34",
        "storage_key": "property/6767906449167598/01a01024-a8eb-775c-b86d-2cdd7a637a34.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A3",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=v9XcvcqzFnV"
    },
    {
      "id": "ec_c7cc3cea4ddb12ce219b86f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "B2 - 2 bed, 2 bath, 1,199 sqft.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-a97e-74b3-b839-e38013884af5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01024-a97e-74b3-b839-e38013884af5",
        "storage_key": "property/6767906449167598/01a01024-a97e-74b3-b839-e38013884af5.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B2",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=x2MvsJw2LsU"
    }
  ],
  "faqs": [
    {
      "id": "custom_224b71ce-8a0f-4f5a-8f49-6c5c4b8fefb0",
      "question": "What are the qualifications for occupancy?",
      "answer": "Check our occupancy qualifications <a href=\"https://www.pricebrotherskc.com/ResidentialRentalQualifications/\">here</a>. We encourage everyone to apply, and hope to have you as a part of our community!",
      "category": "Rental Qualifications",
      "source": "custom"
    },
    {
      "id": "custom_19b6f17e-615c-4a73-ae8d-1e2fdd711add",
      "question": "What is the application fee and is it refundable?",
      "answer": "Application fees are due for each person 18 and older occupying the apartment. All application fees are nonrefundable.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_d4cea9fd-3dc2-4e2e-af32-cf6c02869fb3",
      "question": "What information do I need to apply for an apartment?",
      "answer": "Please review our <a href=\"https://www.pricebrotherskc.com/ResidentialRentalQualifications/\">Qualifications for Occupancy</a>.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_dc1c3379-4f8d-4dce-9eb2-e5685ccafb5d",
      "question": "How do I apply?",
      "answer": "Click on the <a href=\"/apply-now\">Apply Now</a> button under the <a href=\"/floor-plans\">Floor Plans</a> tab of our community website.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_d803c325-bb66-484e-b125-5ed5e047ae22",
      "question": "What is a holding deposit or earnest money?",
      "answer": "A \"holding\" deposit or \"earnest money\" is another word for \"security\" deposit. Please <a href=\"/contact-us\">contact our leasing office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_d9ad7bef-a412-4e37-9007-b599fa10976b",
      "question": "Are there different lease term options available?",
      "answer": "Yes, we offer various lease term options. Please <a href=\"/contact-us\">contact our office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_3d4ffd19-be59-4806-8535-fe31f325f075",
      "question": "Do I need an appointment to take a tour?",
      "answer": "No appointment is necessary to tour our community during business hours; however, it is always appreciated if you call ahead to make sure we are available to provide adequate time for you to tour and ask questions. It is recommended to arrive no later than one half hour prior to closing if you would like to tour the community. Everyone over 18 years of age must have a valid photo ID to tour. Valid forms of identification are decided by Price Brothers Management Company and may include items such as: US Driver’s License, US State Photo ID, US Military Photo ID, US Visa with Photo ID upon it, US Citizenship and Immigration Services Photo ID, Passport.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_e82b5682-f612-4b31-bd5d-e62f72add56e",
      "question": "Do you allow pets?",
      "answer": "Our community is happy to accept cats and dogs. Please refer to our pet section on the <a href=\"/pet-policy\">Pet Policy</a> page.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_56a7a04f-ba25-43ce-a962-5c2988db677f",
      "question": "Do you offer covered parking?",
      "answer": "Select floor plans offer an attached garage. Detached Garages are offered for an additional monthly fee. Please <a href=\"/contact-us\">contact the leasing office</a> for availability.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_ac351034-bd15-4dc7-81c7-500d40fac2c7",
      "question": "What utilities am I responsible to pay?",
      "answer": "Our residents are responsible to pay for water, trash, and electric.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_4b408bb9-66d6-4c36-ad56-4988479d4e48",
      "question": "Why does your pricing include ranges?",
      "answer": "The prices will range on each floor plan depending on location, views, and floor level of the apartment home.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_0b8f5bcf-3b64-4ee4-882b-c9efe9abb4c3",
      "question": "Do you require renters insurance?",
      "answer": "All residents are required to maintain a minimum of $100,000 in liability coverage as part of their lease agreement. For more details on coverage requirements and available options, please <a href=\"/contact-us\">contact our leasing office</a>.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_53432ac3-2128-4a00-9d0a-4645d6d4afbe",
      "question": "How can I refer a friend?",
      "answer": "If you love living here and want to refer a friend, please let our office know! We offer resident referral programs throughout the year and would love for your friends and family to join our community.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_8297acf3-f5c0-4657-8498-3636ef0fe83b",
      "question": "How can I pay my rent?",
      "answer": "You can pay rent by accessing your <a href=\"/resident-access\">resident online account</a>. This allows you to use a bank account or credit card to make payments.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_d288e670-e9ab-4e48-b2aa-ef731fb34cba",
      "question": "Do you offer flexible rent payment options?",
      "answer": "Yes! We’ve partnered with Flex to make paying rent easier for our residents. Flex allows you to split your rent into smaller, more manageable payments throughout the month, giving you added financial flexibility. For more details or to sign up, <a href=\"/contact-us\">contact our leasing office</a> today!",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_ca2c62b8-871f-4758-adee-4f4693cdb5d5",
      "question": "Do you host events at your property?",
      "answer": "Yes, we host events throughout the year with various activities to encourage community camaraderie.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_fb1a3788-3863-4a1b-96cb-2dbe4f995f28",
      "question": "Do you accept packages on behalf of the residents?",
      "answer": "No, we do not offer this service at this time.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_ab4cd46b-e16b-46ae-8ec2-aff7c9e1fc4d",
      "question": "If something needs to be repaired in my apartment, how do I report it?",
      "answer": "You may call the office or submit work orders online by accessing your <a href=\"/resident-access\">resident account</a>. All emergency repairs should be reported by <a href=\"/contact-us\">contacting the office</a>. If the emergency is being reported after business hours, please follow the prompts to be connected to the answering service.",
      "category": "Maintenance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0c9ac-3227-76ff-b08f-f230f3b6afd6",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Cypress at Lewisville Apartment Homes Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598"
    },
    {
      "lead_collector_id": "01a0c9ac-32b8-73c9-b2cc-3bca4661934e",
      "lead_source": "LANDING_PAGE",
      "name": "Cypress at Lewisville Apartment Homes Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "page_item_url": "in-unit-laundry-apartments-lewisville",
      "search_query": "apartments with in-unit laundry lewisville tx",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover seamless living in Lewisville, TX with our apartments offering convenient in-unit laundry. Enjoy modern features designed for comfort.",
      "page_copy": "Experience outstanding living at Cypress at Lewisville Apartment Homes, where convenience meets comfort. Our apartments with in-unit laundry in Lewisville, TX, provide residents with the ease of doing laundry right in the comfort of their home. Featuring spacious one-, two-, and three-bedroom layouts, these contemporary residences come with modern touches like granite countertops, stainless steel appliances, and generous closets, making everyday living more enjoyable.\n\nBeyond the well-appointed interiors, you have access to a community that enhances your lifestyle, including a resort-style pool and fitness center. Those with furry companions will appreciate the dedicated pet play area, and cold winter nights can be cozier with a welcoming fireplace. Located in the vibrant community of Lewisville/Flower Mound, Cypress at Lewisville offers both convenience and a touch of elegance.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with fountains and lounge chairs surrounding it.",
        "public_id": "019fc97a-32ea-729a-a59d-efbae6039b1a",
        "storage_key": "property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lewisville Apartments with In-Unit Laundry",
      "seo_description": "Explore Lewisville, TX apartments with in-unit laundry at Cypress, offering modern amenities and luxurious living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "page_item_url": "pet-friendly-dog-park-lewisville-flower-mound",
      "search_query": "pet friendly apartments with dog park lewisville flower mound",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Dog Park",
      "h2_subtitle": "Enjoy pet-friendly apartments in Lewisville/Flower Mound featuring a dog park. Your furry friends will love their new home too.",
      "page_copy": "At Cypress at Lewisville Apartment Homes, you and your furry companions are more than welcome. Our pet-friendly apartments with a dog park located in the Lewisville/Flower Mound area are perfect for pet owners who want their four-legged friends to enjoy the outdoors without leaving home. The dedicated pet play area provides ample space for exercise and socialization, ensuring your pets have just as much fun as you do.\n\nThese welcoming one-, two-, and three-bedroom apartments boast stylish features such as island kitchens, granite countertops, and stainless steel appliances. The elegance continues with spacious closets and cozy fireplaces, offering a comfortable living experience for you and your pets. Located in the heart of Lewisville/Flower Mound, our community also provides convenient amenities like a resort-style pool and gated access, enhancing both safety and luxury.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with fountains and lounge chairs surrounding it.",
        "public_id": "019fc97a-32ea-729a-a59d-efbae6039b1a",
        "storage_key": "property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Dog Park",
      "seo_description": "Discover pet-friendly living in Lewisville/Flower Mound with a dog park at Cypress, featuring modern amenities and spacious apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "page_item_url": "luxury-apartments-pool-denton-county",
      "search_query": "luxury apartments with pool denton county",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool Access",
      "h2_subtitle": "Experience luxury living in Denton County with our apartments featuring a resort-style pool. Indulge in the finest amenities at Lewisville.",
      "page_copy": "Welcome to Cypress at Lewisville Apartment Homes, where luxury meets convenience. Our luxury apartments with a pool in Denton County offer residents a resort-style lifestyle right at home. Dive into relaxation and enjoy sunny days by our inviting pool, a perfect escape for leisure and social gatherings. \n\nLocated in Lewisville, our one-, two-, and three-bedroom apartments are thoughtfully designed with granite countertops, stainless steel appliances, and fireplace options to elevate your living experience. In addition to the stunning pool, residents have access to a state-of-the-art fitness center, an exclusive clubhouse lounge, and a pet-friendly environment complete with a dog park. Enjoy luxury living in the vibrant Lewisville/Flower Mound area and elevate your everyday life with us.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with fountains and lounge chairs surrounding it.",
        "public_id": "019fc97a-32ea-729a-a59d-efbae6039b1a",
        "storage_key": "property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Denton County",
      "seo_description": "Discover luxury living in Denton County with apartments that offer a resort-style pool and upscale amenities in Lewisville.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "page_item_url": "air-conditioned-apts-fitness-center-75067",
      "search_query": "air conditioned apartments with fitness center 75067",
      "category": "Amenity",
      "h1_title": "Air-Conditioned Apts with Fitness Center",
      "h2_subtitle": "Stay cool in zip code 75067 with our air-conditioned apartments featuring a modern fitness center to keep you active year-round.",
      "page_copy": "Find your ideal home at Cypress at Lewisville Apartment Homes, where comfort meets convenience in the 75067 area. Our air-conditioned apartments ensure you stay comfortable all year round while you enjoy a variety of modern amenities. Residents have access to a state-of-the-art fitness center, ideal for maintaining a healthy lifestyle without leaving the community.\n\nLocated in the vibrant area of Lewisville, our one-, two-, and three-bedroom residences come with premium features like stainless steel appliances, granite countertops, and spacious closets. In addition to the well-equipped fitness center, enjoy other community amenities such as a resort-style pool, a cozy clubhouse lounge, and a pet-friendly environment designed with a dog park. Discover the perfect blend of convenience and comfort at Cypress in Denton County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with fountains and lounge chairs surrounding it.",
        "public_id": "019fc97a-32ea-729a-a59d-efbae6039b1a",
        "storage_key": "property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air-Conditioned Apartments with Fitness Center",
      "seo_description": "Explore air-conditioned apartments in 75067 with a fitness center and superior amenities at Cypress in Lewisville.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "page_item_url": "apartments-dishwasher-lewisville",
      "search_query": "apartments with dishwasher in lewisville",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in Lewisville",
      "h2_subtitle": "Enjoy the convenience of a dishwasher in our perfectly located Lewisville apartments, designed to offer modern living amenities.",
      "page_copy": "Cypress at Lewisville Apartment Homes provides unparalleled modern living with apartments featuring a built-in dishwasher, making daily chores easier. Nestled in the heart of Lewisville, our community offers one-, two-, and three-bedroom layouts, each equipped with stainless steel appliances and granite countertops, ideal for anyone seeking convenience and style.\n\nIn addition to dishwashers, our homes come with spacious closets and fireplaces, elevating comfort at every turn. Venture beyond the kitchen and find more to love with community amenities like a refreshing resort-style pool, a fully-equipped fitness center, and welcoming spaces for pets, including a dedicated dog park. Our Lewisville location, straddling the vibrant Lewisville/Flower Mound neighborhood, ensures that you have everything you need close by while enjoying the convenience of modern apartment living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with fountains and lounge chairs surrounding it.",
        "public_id": "019fc97a-32ea-729a-a59d-efbae6039b1a",
        "storage_key": "property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher in Lewisville",
      "seo_description": "Discover Lewisville apartments with a dishwasher and modern amenities at Cypress, offering convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-lewisville-tx",
      "search_query": "one bedroom apartments lewisville tx",
      "category": "Floorplan",
      "h1_title": "One-Bedroom Apartments in Lewisville, TX",
      "h2_subtitle": "Discover stylish one-bedroom apartments in Lewisville, TX, with modern amenities and a vibrant community atmosphere.",
      "page_copy": "Located in the heart of Lewisville, TX, Cypress at Lewisville Apartment Homes offers stylish one-bedroom apartments designed with your lifestyle in mind. Each unit features granite countertops, stainless steel appliances, and spacious closets, ensuring a seamless blend of luxury and practicality.\n\nOur residents enjoy access to top-tier amenities, including a resort-style pool, a state-of-the-art fitness center, and a pet-friendly environment complete with a dedicated pet play area. Whether you’re commuting from the bustling Lewisville/Flower Mound neighborhood or unwinding by your cozy fireplace, our community pairs convenience with comfort. Schedule a tour today to explore our one-bedroom options and envision your new home in Lewisville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with fountains and lounge chairs surrounding it.",
        "public_id": "019fc97a-32ea-729a-a59d-efbae6039b1a",
        "storage_key": "property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One-Bedroom Apartments in Lewisville, TX",
      "seo_description": "Explore one-bedroom apartments in Lewisville, TX, featuring modern amenities at Cypress for elevated living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-denton-county",
      "search_query": "two bedroom apartments in denton county",
      "category": "Floorplan",
      "h1_title": "Two-Bedroom Apartments in Denton County",
      "h2_subtitle": "Explore spacious two-bedroom apartments nestled in Denton County, offering modern features and exceptional community amenities.",
      "page_copy": "Cypress at Lewisville Apartment Homes is proud to offer two-bedroom apartments tailored for comfort and style within Denton County. Our residences feature spacious interiors with granite countertops, stainless steel appliances, and ample closet space, perfect for those seeking a modern living experience.\n\nBeyond the front door, enjoy our resort-style amenities, including a shimmering pool, a cutting-edge fitness center, and a vibrant clubhouse lounge. The community is also pet-friendly, boasting a dedicated play area for your furry friends. Located conveniently in Lewisville, part of the lively Lewisville/Flower Mound neighborhood, our apartments ensure you're never far from local attractions and essential services. Discover the perfect blend of convenience and comfort in our two-bedroom layouts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with fountains and lounge chairs surrounding it.",
        "public_id": "019fc97a-32ea-729a-a59d-efbae6039b1a",
        "storage_key": "property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two-Bedroom Apartments in Denton County",
      "seo_description": "Find two-bedroom apartments with modern amenities in Denton County at Cypress.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-near-75067",
      "search_query": "three bedroom apartments near 75067",
      "category": "Floorplan",
      "h1_title": "Three-Bedroom Apartments Near 75067",
      "h2_subtitle": "Discover spacious three-bedroom apartments near the 75067 area, offering exceptional amenities and a vibrant community setting.",
      "page_copy": "Cypress at Lewisville Apartment Homes offers spacious three-bedroom apartments in the 75067 ZIP code, featuring granite countertops, stainless steel appliances, and large closets for convenient storage.\n\nCommunity amenities include a resort-style pool, a fitness center, and a clubhouse lounge. The gated community also features a designated pet play area. Located in the Lewisville/Flower Mound area, Cypress at Lewisville provides convenient access to local shopping, dining, entertainment, and other destinations throughout the surrounding area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with fountains and lounge chairs surrounding it.",
        "public_id": "019fc97a-32ea-729a-a59d-efbae6039b1a",
        "storage_key": "property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three-Bedroom Apartments Near 75067",
      "seo_description": "Find spacious three-bedroom apartments near 75067 at Cypress, offering modern amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "page_item_url": "apartments-near-parkway-elementary-lewisville-tx",
      "search_query": "apartments near parkway elementary lewisville tx",
      "category": "School",
      "h1_title": "Apartments Near Parkway Elementary in Lewisville",
      "h2_subtitle": "Discover apartments near Parkway Elementary in Lewisville, TX, at Cypress at Lewisville, featuring modern interiors and convenient community amenities.",
      "page_copy": "Cypress at Lewisville Apartment Homes offers one-, two-, and three-bedroom apartments near Parkway Elementary in Lewisville, TX. Apartment features include granite countertops, stainless steel appliances, and spacious closets.\n\nCommunity amenities include a resort-style pool, a fitness center, and a clubhouse lounge. The pet-friendly community also features a designated pet play area. Located in the Lewisville/Flower Mound area, Cypress at Lewisville provides convenient access to Parkway Elementary, shopping, dining, entertainment, and other destinations throughout Denton County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with fountains and lounge chairs surrounding it.",
        "public_id": "019fc97a-32ea-729a-a59d-efbae6039b1a",
        "storage_key": "property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Parkway Elementary, Lewisville",
      "seo_description": "Find modern apartments near Parkway Elementary in Lewisville, TX, at Cypress at Lewisville, featuring spacious floor plans and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "page_item_url": "cypress-lewisville-apartments-near-lillie-j-jackson",
      "search_query": "cypress at lewisville apartments lillie j. jackson early childhood center vicinity",
      "category": "School",
      "h1_title": "Cypress at Lewisville Near Lillie J. Jackson",
      "h2_subtitle": "Explore Cypress at Lewisville Apartments, located conveniently near Lillie J. Jackson Early Childhood Center, offering community lifestyle and modern comforts.",
      "page_copy": "Cypress at Lewisville Apartment Homes offers a convenient location near Lillie J. Jackson Early Childhood Center in the Lewisville/Flower Mound area. Our community features one-, two-, and three-bedroom apartments with stainless steel appliances, granite countertops, and spacious closets.\n\nCommunity amenities include a resort-style pool, a fitness center, and a clubhouse lounge. The pet-friendly community also features a designated pet play area. Located near local schools, shopping, dining, and other services, Cypress at Lewisville provides convenient access to destinations throughout Lewisville and Flower Mound.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with fountains and lounge chairs surrounding it.",
        "public_id": "019fc97a-32ea-729a-a59d-efbae6039b1a",
        "storage_key": "property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cypress at Lewisville Near Lillie J. Jackson Center",
      "seo_description": "Explore Cypress at Lewisville Apartments, close to Lillie J. Jackson Early Childhood Center, with modern living and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "page_item_url": "lewisville-apartments-near-hedrick-middle-school",
      "search_query": "hedrick middle school nearby lewisville apartments",
      "category": "School",
      "h1_title": "Lewisville Apartments Near Hedrick Middle School",
      "h2_subtitle": "Find the perfect Lewisville apartments near Hedrick Middle School with a range of amenities and spacious floor plans.",
      "page_copy": "Cypress at Lewisville Apartment Homes offers a convenient location near Hedrick Middle School in the Lewisville/Flower Mound area. Our community features one-, two-, and three-bedroom apartments with granite countertops, stainless steel appliances, and spacious closets.\n\nCommunity amenities include a resort-style pool, a fitness center, and a clubhouse lounge. The gated community also features a designated pet play area. Located near local schools, shopping, dining, and entertainment, Cypress at Lewisville provides convenient access to destinations throughout the surrounding area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with fountains and lounge chairs surrounding it.",
        "public_id": "019fc97a-32ea-729a-a59d-efbae6039b1a",
        "storage_key": "property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lewisville Apartments Near Hedrick Middle School",
      "seo_description": "Explore Cypress at Lewisville Apartments near Hedrick Middle School, offering modern amenities and spacious living options.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "page_item_url": "denton-county-apartments-near-durham-middle-school",
      "search_query": "durham middle school denton county apartments",
      "category": "School",
      "h1_title": "Denton County Apartments Near Durham Middle School",
      "h2_subtitle": "Explore convenient Denton County apartment living near Durham Middle School, complete with modern amenities and spacious layouts.",
      "page_copy": "Cypress at Lewisville Apartment Homes offers one-, two-, and three-bedroom apartments near Durham Middle School in Denton County. Apartment features include granite countertops, stainless steel appliances, and spacious closets.\n\nCommunity amenities include a resort-style pool, a fitness center, and a clubhouse lounge. The pet-friendly community also features a designated pet play area. Located in the Lewisville/Flower Mound area, Cypress at Lewisville provides convenient access to local schools, recreational spaces, shopping, dining, and entertainment throughout Denton County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with fountains and lounge chairs surrounding it.",
        "public_id": "019fc97a-32ea-729a-a59d-efbae6039b1a",
        "storage_key": "property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Denton County Apartments Near Durham Middle School",
      "seo_description": "Find modern Denton County apartments near Durham Middle School at Cypress, featuring extensive amenities and comfortable living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "page_item_url": "lewisville-apartments-near-huffines-middle-school",
      "search_query": "huffines middle school close to lewisville apartments",
      "category": "School",
      "h1_title": "Lewisville Apartments Near Huffines Middle School",
      "h2_subtitle": "Discover Lewisville living close to Huffines Middle School, offering modern apartments with a host of amenities and spacious floor plans.",
      "page_copy": "Cypress at Lewisville Apartment Homes offers a convenient location near Huffines Middle School in the Lewisville/Flower Mound area. Our community features spacious one-, two-, and three-bedroom apartments with stainless steel appliances, granite countertops, and ample closet storage.\n\nCommunity amenities include a resort-style pool, a fitness center, and a clubhouse lounge. The gated community also features a designated pet play area. Located near local schools, shopping, dining, and other destinations, Cypress at Lewisville provides convenient access to amenities and services throughout the surrounding area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with fountains and lounge chairs surrounding it.",
        "public_id": "019fc97a-32ea-729a-a59d-efbae6039b1a",
        "storage_key": "property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lewisville Apartments Near Huffines Middle School",
      "seo_description": "Explore modern apartments in Lewisville near Huffines Middle School, featuring spacious floor plans and convenient community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "page_item_url": "apartments-near-lewisville-high-school",
      "search_query": "lewisville high school area apartments",
      "category": "School",
      "h1_title": "Apartments Near Lewisville High School",
      "h2_subtitle": "Discover convenient living with Lewisville High School area apartments, offering modern features and outstanding community amenities.",
      "page_copy": "Cypress at Lewisville Apartment Homes provides an ideal setting for those seeking apartments near Lewisville High School. Our community features a variety of one-, two-, and three-bedroom layouts, designed with modern comforts including granite countertops, stainless steel appliances, and plenty of closet space.\n\nResidents will appreciate the range of amenities available, such as a resort-style swimming pool, a state-of-the-art fitness center, and a comfortable clubhouse lounge perfect for socializing. The community is gated, offering added peace of mind, while pet owners will enjoy our dedicated pet play area. Positioned in the sought-after Lewisville/Flower Mound neighborhood, Cypress at Lewisville combines location and lifestyle, providing easy access to education, shopping, and dining options.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with fountains and lounge chairs surrounding it.",
        "public_id": "019fc97a-32ea-729a-a59d-efbae6039b1a",
        "storage_key": "property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lewisville High School",
      "seo_description": "Discover modern living in apartments near Lewisville High School, featuring luxury amenities and convenient access in a vibrant neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "page_item_url": "lewisville-flower-mound-apartments-near-mill-street-elementary",
      "search_query": "mill street elementary school apartments in lewisville flower mound neighborhood",
      "category": "School",
      "h1_title": "Lewisville Apartments Near Mill Street Elementary",
      "h2_subtitle": "Explore Lewisville Flower Mound neighborhood apartments, ideally situated near Mill Street Elementary School with exceptional amenities.",
      "page_copy": "Cypress at Lewisville Apartment Homes offers one-, two-, and three-bedroom apartments near Mill Street Elementary School in the Lewisville/Flower Mound area. Apartment features include granite countertops, stainless steel appliances, and spacious closets designed for everyday functionality.\n\nCommunity amenities include a resort-style pool, a fitness center, and a clubhouse lounge. The gated community also features a designated pet play area. Located near local schools, shopping, dining, and other destinations, Cypress at Lewisville provides convenient connections to amenities and services throughout the surrounding area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with fountains and lounge chairs surrounding it.",
        "public_id": "019fc97a-32ea-729a-a59d-efbae6039b1a",
        "storage_key": "property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lewisville Apartments Near Mill Street Elementary",
      "seo_description": "Choose Lewisville Flower Mound apartments near Mill Street Elementary, offering modern amenities in a vibrant neighborhood setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "page_item_url": "lewisville-apartments-near-student-success-center",
      "search_query": "student success center within reach of lewisville apartment homes",
      "category": "School",
      "h1_title": "Apartments Near Student Success Center Lewisville",
      "h2_subtitle": "Find Lewisville apartments within reach of the Student Success Center, featuring modern amenities and a dynamic living experience.",
      "page_copy": "Cypress at Lewisville Apartment Homes is perfectly situated for anyone looking to be near the Student Success Center in Lewisville. Our contemporary one-, two-, and three-bedroom apartments are designed with upscale touches such as granite countertops, stainless steel appliances, and spacious closets that meet your lifestyle needs.\n\nLiving here, you'll benefit from community amenities that cater to convenience and leisure. Take a refreshing dip in the resort-style pool, maintain an exercise routine at the fitness center, or relax in the inviting clubhouse lounge. Our gated community also boasts a pet play area, ensuring entertainment for all family members. Located in the vibrant Lewisville/Flower Mound district, Cypress at Lewisville combines access to educational resources like the Student Success Center with the comfort of upscale living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with fountains and lounge chairs surrounding it.",
        "public_id": "019fc97a-32ea-729a-a59d-efbae6039b1a",
        "storage_key": "property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lewisville Apartments Near Student Success Center",
      "seo_description": "Explore modern living with Lewisville apartments near the Student Success Center, boasting luxury amenities and a vibrant community lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "page_item_url": "lewisville-apartments-near-university-of-north-texas",
      "search_query": "university of north texas nearby lewisville apartments",
      "category": "School",
      "h1_title": "Lewisville Apartments Near UNT",
      "h2_subtitle": "Discover apartments in Lewisville near the University of North Texas, offering modern living spaces with convenient access and superior amenities.",
      "page_copy": "Cypress at Lewisville Apartment Homes offers an ideal location for those desiring proximity to the University of North Texas. Our community provides beautifully designed one-, two-, and three-bedroom apartments with upscale features like granite countertops, stainless steel appliances, and ample closet space, ensuring a comfortable and stylish living environment.\n\nResidents can enjoy an array of exceptional amenities, including a resort-style swimming pool perfect for relaxation, a well-equipped fitness center, and a plush clubhouse lounge for social gatherings. Our gated community also includes a pet play area, proving pet-friendly living is at its finest. Nestled in the lively Lewisville/Flower Mound neighborhood, Cypress at Lewisville combines easy access to academic institutions with a vibrant community spirit, making it the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with fountains and lounge chairs surrounding it.",
        "public_id": "019fc97a-32ea-729a-a59d-efbae6039b1a",
        "storage_key": "property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lewisville Apartments Near UNT",
      "seo_description": "Find modern Lewisville apartments near the University of North Texas, featuring luxury amenities in a dynamic community setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "page_item_url": "apartments-near-medical-city-lewisville",
      "search_query": "apartments near medical city lewisville",
      "category": "Hospital",
      "h1_title": "Lewisville Apartments Near Medical City",
      "h2_subtitle": "Explore premium living options with apartments near Medical City Lewisville, offering top-notch amenities and a prime location.",
      "page_copy": "Cypress at Lewisville Apartment Homes offers one-, two-, and three-bedroom apartments in the Lewisville/Flower Mound area, near Medical City Lewisville. Apartment features include granite countertops, stainless steel appliances, and spacious closets with ample storage.\n\nCommunity amenities include a resort-style pool, a fitness center, and a clubhouse lounge. The gated community also features a designated pet play area. Located near major destinations in Lewisville and Flower Mound, Cypress at Lewisville offers convenient access to local healthcare facilities, shopping, dining, and other area destinations.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with fountains and lounge chairs surrounding it.",
        "public_id": "019fc97a-32ea-729a-a59d-efbae6039b1a",
        "storage_key": "property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lewisville Apartments Near Medical City",
      "seo_description": "Choose Lewisville apartments near Medical City for luxury living with robust amenities in a prime neighborhood location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "page_item_url": "apartments-near-texas-health-presbyterian-flower-mound",
      "search_query": "apartments close to texas health presbyterian hospital flower mound denton county",
      "category": "Hospital",
      "h1_title": "Apartments Near Texas Health Presbyterian Hospital",
      "h2_subtitle": "Discover nearby apartments offering modern amenities near Texas Health Presbyterian Hospital, located in Denton County.",
      "page_copy": "Cypress at Lewisville Apartment Homes provides an exceptional living experience close to Texas Health Presbyterian Hospital in Flower Mound. Our thoughtfully designed one-, two-, and three-bedroom apartments come complete with high-end features such as granite countertops, stainless steel appliances, and large closets, perfect for anyone seeking comfort and convenience.\n\nResidents can enjoy a variety of community amenities, including a refreshing resort-style pool, a state-of-the-art fitness center, and a chic clubhouse lounge ideal for relaxation or socializing. Our gated community also supports a pet-friendly lifestyle, featuring a dedicated pet play area. Nestled within the vibrant Denton County, Cypress at Lewisville ensures easy access to essential healthcare services as well as a lively neighborhood atmosphere, making it a perfect place to live.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with fountains and lounge chairs surrounding it.",
        "public_id": "019fc97a-32ea-729a-a59d-efbae6039b1a",
        "storage_key": "property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Texas Health Presbyterian Flower Mound",
      "seo_description": "Find luxury apartments near Texas Health Presbyterian Hospital in Flower Mound, Denton County, with excellent amenities and prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "page_item_url": "apartments-near-memorial-park-lewisville",
      "search_query": "apartments near Memorial Park Lewisville TX",
      "category": "Park",
      "h1_title": "Apartments Near Memorial Park Lewisville",
      "h2_subtitle": "Explore versatile living spaces near Memorial Park in Lewisville, TX, featuring top-notch amenities and a lively community atmosphere.",
      "page_copy": "Cypress at Lewisville Apartment Homes offers a prime location just moments away from Memorial Park in Lewisville, TX. Our beautifully appointed one-, two-, and three-bedroom apartments feature modern amenities such as granite countertops, stainless steel appliances, and generous closet space, making these homes ideal for those seeking convenience and style.\n\nThe community is enriched with amenities including a spacious resort-style pool, a comprehensive fitness center, and an inviting clubhouse lounge, perfect for both relaxing and gathering with friends. Additionally, our gated community includes a playful pet area, ensuring that all family members are welcome. The proximity to Memorial Park provides ample opportunities for outdoor activities and leisure, while the vibrant Lewisville/Flower Mound neighborhood offers plenty of dining and entertainment options.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with fountains and lounge chairs surrounding it.",
        "public_id": "019fc97a-32ea-729a-a59d-efbae6039b1a",
        "storage_key": "property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Memorial Park Lewisville, TX",
      "seo_description": "Choose modern, luxurious apartments near Memorial Park in Lewisville, TX, offering excellent amenities in a vibrant neighborhood setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "page_item_url": "cypress-apartments-near-lewisville-railroad-park",
      "search_query": "Cypress apartments close to Lewisville Railroad Park",
      "category": "Park",
      "h1_title": "Cypress Apartments Near Railroad Park",
      "h2_subtitle": "Enjoy modern living at Cypress Apartments, just minutes away from Lewisville Railroad Park, with amenities designed for your comfort.",
      "page_copy": "Cypress at Lewisville Apartment Homes offers a convenient location near Lewisville Railroad Park, with access to outdoor recreation and destinations throughout Lewisville and Flower Mound. Our one-, two-, and three-bedroom apartments feature granite countertops, stainless steel appliances, and ample closet storage.\n\nCommunity amenities include a resort-style pool, a fitness center, and a clubhouse lounge. The gated, pet-friendly community also features a designated pet play area. Located near Lewisville Railroad Park, Cypress at Lewisville provides convenient access to outdoor spaces, shopping, dining, and other local destinations.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with fountains and lounge chairs surrounding it.",
        "public_id": "019fc97a-32ea-729a-a59d-efbae6039b1a",
        "storage_key": "property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cypress Apartments Near Lewisville Railroad Park",
      "seo_description": "Discover Cypress Apartments near Lewisville Railroad Park, featuring luxurious amenities and a prime location in the heart of Lewisville.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "page_item_url": "living-near-vista-ridge-athletic-complex-lewisville",
      "search_query": "living near Vista Ridge Athletic Complex Lewisville",
      "category": "Park",
      "h1_title": "Living Near Vista Ridge Athletic Complex",
      "h2_subtitle": "Experience active living near Vista Ridge Athletic Complex in Lewisville, with modern apartments and exceptional community amenities.",
      "page_copy": "Cypress at Lewisville Apartment Homes offers a vibrant living experience near the Vista Ridge Athletic Complex. Our well-appointed one-, two-, and three-bedroom apartments feature luxurious details like granite countertops, stainless steel appliances, and spacious closets, ensuring residents have a comfortable and chic living space.\n\nBeyond the apartment interiors, residents can enjoy top-tier community amenities including a sparkling resort-style pool, a comprehensive fitness center, and a cozy clubhouse lounge ideal for social gatherings. The gated community also features a pet play area, welcoming furry friends and their owners alike. Situated close to the Vista Ridge Athletic Complex, Cypress at Lewisville is perfect for sports enthusiasts and those who enjoy active lifestyles, all while having access to the vibrant offerings of Lewisville and Flower Mound.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with fountains and lounge chairs surrounding it.",
        "public_id": "019fc97a-32ea-729a-a59d-efbae6039b1a",
        "storage_key": "property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Vista Ridge Athletic Complex, Lewisville",
      "seo_description": "Explore active living near Vista Ridge Athletic Complex in Lewisville, offering stylish apartments and excellent amenities for a dynamic lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "page_item_url": "cypress-at-lewisville-next-to-meadowlake-park",
      "search_query": "Cypress at Lewisville homes next to Meadowlake Park",
      "category": "Park",
      "h1_title": "Cypress at Lewisville Next to Meadowlake Park",
      "h2_subtitle": "Discover the charm of living at Cypress at Lewisville, located next to Meadowlake Park, with exceptional amenities and stylish interiors.",
      "page_copy": "Strategically positioned next to Meadowlake Park, Cypress at Lewisville Apartment Homes provides an unparalleled residential experience. Our modern one-, two-, and three-bedroom apartments are finely appointed with granite countertops, stainless steel appliances, and expansive closets, offering a perfect blend of style and functionality.\n\nResidents can indulge in community luxuries such as a sparkling resort-style pool, a fully equipped fitness center, and a welcoming clubhouse lounge ideal for relaxation and socializing. Our gated community is pet-friendly and includes a dedicated pet play area. With Meadowlake Park just a stone's throw away, residents can take advantage of outdoor activities and serene surroundings, while also enjoying the vibrant lifestyle that Lewisville/Flower Mound has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with fountains and lounge chairs surrounding it.",
        "public_id": "019fc97a-32ea-729a-a59d-efbae6039b1a",
        "storage_key": "property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cypress at Lewisville Homes Next to Meadowlake Park",
      "seo_description": "Experience refined living at Cypress at Lewisville next to Meadowlake Park, offering modern amenities in a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "page_item_url": "apartments-in-denton-county-near-orchard-valley-park",
      "search_query": "apartments in Denton County near Orchard Valley Park",
      "category": "Park",
      "h1_title": "Apartments Near Orchard Valley Park",
      "h2_subtitle": "Find premium apartment living in Denton County, just a short distance from Orchard Valley Park, offering top-tier amenities and spacious homes.",
      "page_copy": "Cypress at Lewisville Apartment Homes is ideally situated in Denton County, providing convenient access to Orchard Valley Park. Our selection of upscale one-, two-, and three-bedroom apartments ensures residents enjoy superior quality with features like sleek granite countertops, stainless steel appliances, and generous closet space, perfect for modern lifestyles.\n\nBeyond the exceptional apartment interiors, the community offers premium amenities including a resort-style swimming pool, state-of-the-art fitness center, and a comfortable clubhouse lounge. Dog owners will appreciate the dedicated pet play area in our pet-friendly, gated community. With Orchard Valley Park nearby, residents can easily enjoy outdoor activities while benefiting from the vibrant surroundings and comforts of the Lewisville/Flower Mound neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with fountains and lounge chairs surrounding it.",
        "public_id": "019fc97a-32ea-729a-a59d-efbae6039b1a",
        "storage_key": "property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments in Denton County Near Orchard Valley Park",
      "seo_description": "Explore luxurious apartments in Denton County near Orchard Valley Park, offering modern amenities and a prime location in the heart of Lewisville.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167598",
      "source": "custom",
      "page_item_url": "apartments-near-dallas-fort-worth-airport-lewisville",
      "search_query": "apartments near dallas fort worth international airport lewisville",
      "category": "Transit",
      "h1_title": "Apartments Near DFW Airport in Lewisville",
      "h2_subtitle": "Convenience meets comfort at Cypress at Lewisville, with easy access to Dallas Fort Worth International Airport and a wealth of modern amenities.",
      "page_copy": "Located within a convenient drive from Dallas Fort Worth International Airport, Cypress at Lewisville Apartment Homes offers a perfect blend of accessibility and luxury. Our elegant one-, two-, and three-bedroom apartments feature high-end finishes like granite countertops, stainless steel appliances, and ample closet space, catering to the needs of frequent travelers and busy professionals.\n\nThe community amenities include a resort-style pool, a fully equipped fitness center, and a stylish clubhouse lounge, providing residents with relaxing and engaging social spaces. As a gated community, Cypress at Lewisville welcomes pets, boasting a dedicated pet play area for your furry companions. Its prime location near the airport makes it an ideal residence for those seeking modern convenience in a vibrant Lewisville/Flower Mound community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with fountains and lounge chairs surrounding it.",
        "public_id": "019fc97a-32ea-729a-a59d-efbae6039b1a",
        "storage_key": "property/6767906449167598/019fc97a-32ea-729a-a59d-efbae6039b1a.webp",
        "width": 3072,
        "height": 2047
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Dallas Fort Worth Airport in Lewisville",
      "seo_description": "Discover convenience at Cypress at Lewisville, offering stylish apartments near Dallas Fort Worth International Airport with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701892541"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KD4966RK"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 3"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Rise"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/3c70a37f-4306-4316-91de-838ffb600d0e/app.js?nocache=1&gaTracking=G-HQ3XSW5FFT&buttonbgcolor=78be20&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://homes.rently.com/apartments-for-rent/Cypress%20at%20Lewisville/61042"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "972-203-6495"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Imc4NXlRWFh3TTJmd0FPaUc5elNmL3c9PSIsInZhbHVlIjoiMkdHVEZVOGNiTGtuMWQyeGIyZHo2UT09IiwibWFjIjoiMjE3ZjdiZDdlZGY4NWMyY2YzMDQ3MDc1MzI1ZTc0NDhjZWRkMzc2NWZmYzdjZmVjMDllOGJiZjMzOTgyMmY0ZCJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701892541",
  "custom_google_gtm_id": "GTM-KD4966RK",
  "custom_rollout_phase": "Batch 3",
  "custom_vibesites_theme": "Rise",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/3c70a37f-4306-4316-91de-838ffb600d0e/app.js?nocache=1&gaTracking=G-HQ3XSW5FFT&buttonbgcolor=78be20&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_self_guided_tour_url": "https://homes.rently.com/apartments-for-rent/Cypress%20at%20Lewisville/61042",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "972-203-6495",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Imc4NXlRWFh3TTJmd0FPaUc5elNmL3c9PSIsInZhbHVlIjoiMkdHVEZVOGNiTGtuMWQyeGIyZHo2UT09IiwibWFjIjoiMjE3ZjdiZDdlZGY4NWMyY2YzMDQ3MDc1MzI1ZTc0NDhjZWRkMzc2NWZmYzdjZmVjMDllOGJiZjMzOTgyMmY0ZCJ9",
  "custom_audioeye_site_id": "f78366b0-77d6-4238-a9f0-e7ac2f69a656",
  "custom_audioeye_site_hash": "53ff5ed67c0cb2ec1a6a7d761012956e"
};

export const generatedAt = '2026-11-03T23:00:59.898Z';
